[
  {
    "categories": [],
    "name": "1plusX",
    "type": "1plusx"
  },
  {
    "categories": [],
    "name": "1WorldSync",
    "type": "1worldsync"
  },
  {
    "categories": [],
    "name": "2C2P",
    "type": "2c2p"
  },
  {
    "categories": [],
    "name": "370.AI",
    "type": "370ai"
  },
  {
    "categories": [],
    "name": "4.events",
    "type": "4events"
  },
  {
    "categories": [],
    "name": "4Dem",
    "type": "4dem"
  },
  {
    "categories": [],
    "name": "5 Stars Reputation",
    "type": "5starsreputation"
  },
  {
    "categories": [],
    "name": "5day.io",
    "type": "5dayio"
  },
  {
    "categories": [],
    "name": "8B World",
    "type": "8bworld"
  },
  {
    "categories": [],
    "name": "Acuris Compliance",
    "type": "acuriscompliance"
  },
  {
    "categories": [],
    "name": "Adaptek KonnexMe",
    "type": "adaptekkonnexme"
  },
  {
    "categories": [],
    "name": "Adgogo",
    "type": "adgogo"
  },
  {
    "categories": [],
    "name": "adhook",
    "type": "adhook"
  },
  {
    "categories": [],
    "name": "Adjust",
    "type": "adjust"
  },
  {
    "categories": [],
    "name": "Admanage AI",
    "type": "admanageai"
  },
  {
    "categories": [],
    "name": "Administrate",
    "type": "administrate"
  },
  {
    "categories": [],
    "name": "Adobe Experience Manager",
    "type": "adobeexperiencemanager"
  },
  {
    "categories": [],
    "name": "aevent",
    "type": "aevent"
  },
  {
    "categories": [],
    "name": "Afosto",
    "type": "afosto"
  },
  {
    "categories": [],
    "name": "Agentboxd",
    "type": "agentboxd"
  },
  {
    "categories": [],
    "name": "agentOS",
    "type": "agentos"
  },
  {
    "categories": [],
    "name": "Agillic",
    "type": "agillic"
  },
  {
    "categories": [],
    "name": "Ahrefs",
    "type": "ahrefs"
  },
  {
    "categories": [],
    "name": "AI Number",
    "type": "ainumber"
  },
  {
    "categories": [],
    "name": "Aidbase",
    "type": "aidbase"
  },
  {
    "categories": [],
    "name": "AIRe Link",
    "type": "airelink"
  },
  {
    "categories": [],
    "name": "AITable",
    "type": "aitable"
  },
  {
    "categories": [],
    "name": "Akada",
    "type": "akada"
  },
  {
    "categories": [],
    "name": "Akazte",
    "type": "akazte"
  },
  {
    "categories": [],
    "name": "Aliaddo",
    "type": "aliaddo"
  },
  {
    "categories": [],
    "name": "AliExpress",
    "type": "aliexpress"
  },
  {
    "categories": [],
    "name": "All-Images.ai",
    "type": "allimagesai"
  },
  {
    "categories": [],
    "name": "allGeo",
    "type": "allgeo"
  },
  {
    "categories": [],
    "name": "Alloy",
    "type": "alloy"
  },
  {
    "categories": [],
    "name": "Alma",
    "type": "alma"
  },
  {
    "categories": [],
    "name": "Alpha TransForm",
    "type": "alphatransform"
  },
  {
    "categories": [],
    "name": "Altiria",
    "type": "altiria"
  },
  {
    "categories": [],
    "name": "alwaysdata",
    "type": "alwaysdata"
  },
  {
    "categories": [],
    "name": "Amadeus Hospitality",
    "type": "amadeushospitality"
  },
  {
    "categories": [],
    "name": "Amazon Polly",
    "type": "amazonpolly"
  },
  {
    "categories": [],
    "name": "Amazon SES",
    "type": "amazonses"
  },
  {
    "categories": [],
    "name": "Ambivo",
    "type": "ambivo"
  },
  {
    "categories": [],
    "name": "Amilia SmartRec",
    "type": "amiliasmartrec"
  },
  {
    "categories": [],
    "name": "Annature",
    "type": "annature"
  },
  {
    "categories": [],
    "name": "Annex Cloud",
    "type": "annexcloud"
  },
  {
    "categories": [],
    "name": "Antavo",
    "type": "antavo"
  },
  {
    "categories": [],
    "name": "Antsroute",
    "type": "antsroute"
  },
  {
    "categories": [],
    "name": "Anymail Finder",
    "type": "anymailfinder"
  },
  {
    "categories": [],
    "name": "Apacta",
    "type": "apacta"
  },
  {
    "categories": [],
    "name": "Apex27",
    "type": "apex27"
  },
  {
    "categories": [],
    "name": "AppDeploy",
    "type": "appdeploy"
  },
  {
    "categories": [],
    "name": "Apple iCloud Store Connection",
    "type": "appleicloudstoreconnection"
  },
  {
    "categories": [],
    "name": "AppsFlyer",
    "type": "appsflyer"
  },
  {
    "categories": [],
    "name": "Appwrite",
    "type": "appwrite"
  },
  {
    "categories": [],
    "name": "Aprimo",
    "type": "aprimo"
  },
  {
    "categories": [],
    "name": "Apto Payments",
    "type": "aptopayments"
  },
  {
    "categories": [],
    "name": "Arbox",
    "type": "arbox"
  },
  {
    "categories": [],
    "name": "Argorant",
    "type": "argorant"
  },
  {
    "categories": [],
    "name": "AroFlo",
    "type": "aroflo"
  },
  {
    "categories": [],
    "name": "Arrangr",
    "type": "arrangr"
  },
  {
    "categories": [],
    "name": "ArvanCloud Object Storage",
    "type": "arvancloudobjectstorage"
  },
  {
    "categories": [],
    "name": "Arventa WHS Monitor",
    "type": "arventawhsmonitor"
  },
  {
    "categories": [],
    "name": "Aryeo",
    "type": "aryeo"
  },
  {
    "categories": [],
    "name": "Áskell",
    "type": "skell"
  },
  {
    "categories": [],
    "name": "AskNicely",
    "type": "asknicely"
  },
  {
    "categories": [],
    "name": "Assembly",
    "type": "assembly"
  },
  {
    "categories": [],
    "name": "AssemblyAI",
    "type": "assemblyai"
  },
  {
    "categories": [],
    "name": "Assignar",
    "type": "assignar"
  },
  {
    "categories": [],
    "name": "AstroFabric",
    "type": "astrofabric"
  },
  {
    "categories": [],
    "name": "Atarim",
    "type": "atarim"
  },
  {
    "categories": [],
    "name": "Atera",
    "type": "atera"
  },
  {
    "categories": [],
    "name": "AtlasRTX",
    "type": "atlasrtx"
  },
  {
    "categories": [],
    "name": "Atlassian Fisheye/Crucible",
    "type": "atlassianfisheyecrucible"
  },
  {
    "categories": [],
    "name": "Attentive",
    "type": "attentive"
  },
  {
    "categories": [],
    "name": "Audienceful",
    "type": "audienceful"
  },
  {
    "categories": [],
    "name": "AurasPay",
    "type": "auraspay"
  },
  {
    "categories": [],
    "name": "Aurora Inbox",
    "type": "aurorainbox"
  },
  {
    "categories": [],
    "name": "Autoposting.ai",
    "type": "autopostingai"
  },
  {
    "categories": [],
    "name": "Availity",
    "type": "availity"
  },
  {
    "categories": [],
    "name": "Avalara AvaTax",
    "type": "avalaraavatax"
  },
  {
    "categories": [],
    "name": "Avaza",
    "type": "avaza"
  },
  {
    "categories": [],
    "name": "Awin",
    "type": "awin"
  },
  {
    "categories": [],
    "name": "AWS Amplify",
    "type": "awsamplify"
  },
  {
    "categories": [],
    "name": "AWS App Runner",
    "type": "awsapprunner"
  },
  {
    "categories": [],
    "name": "AWS IAM Identity Center",
    "type": "awsiamidentitycenter"
  },
  {
    "categories": [],
    "name": "AWS Marketplace",
    "type": "awsmarketplace"
  },
  {
    "categories": [],
    "name": "Axerto",
    "type": "axerto"
  },
  {
    "categories": [],
    "name": "Axosoft",
    "type": "axosoft"
  },
  {
    "categories": [],
    "name": "Azure App Service",
    "type": "azureappservice"
  },
  {
    "categories": [],
    "name": "Azure Batch",
    "type": "azurebatch"
  },
  {
    "categories": [],
    "name": "Azure Container Instances",
    "type": "azurecontainerinstances"
  },
  {
    "categories": [],
    "name": "B2Brouter",
    "type": "b2brouter"
  },
  {
    "categories": [],
    "name": "Back4App",
    "type": "back4app"
  },
  {
    "categories": [],
    "name": "Backblaze B2",
    "type": "backblazeb2"
  },
  {
    "categories": [],
    "name": "Backendless",
    "type": "backendless"
  },
  {
    "categories": [],
    "name": "Bagisto",
    "type": "bagisto"
  },
  {
    "categories": [],
    "name": "Bancontact Payconiq",
    "type": "bancontactpayconiq"
  },
  {
    "categories": [],
    "name": "BankID Norway",
    "type": "bankidnorway"
  },
  {
    "categories": [],
    "name": "BarBrain",
    "type": "barbrain"
  },
  {
    "categories": [],
    "name": "Baseten",
    "type": "baseten"
  },
  {
    "categories": [],
    "name": "Basile",
    "type": "basile"
  },
  {
    "categories": [],
    "name": "Basin",
    "type": "basin"
  },
  {
    "categories": [],
    "name": "Bbot",
    "type": "bbot"
  },
  {
    "categories": [],
    "name": "beBettor",
    "type": "bebettor"
  },
  {
    "categories": [],
    "name": "Beebole",
    "type": "beebole"
  },
  {
    "categories": [],
    "name": "Beebs",
    "type": "beebs"
  },
  {
    "categories": [],
    "name": "BEEKAI",
    "type": "beekai"
  },
  {
    "categories": [],
    "name": "BeezUP",
    "type": "beezup"
  },
  {
    "categories": [],
    "name": "Benetics",
    "type": "benetics"
  },
  {
    "categories": [],
    "name": "BentoCloud",
    "type": "bentocloud"
  },
  {
    "categories": [],
    "name": "bidbuild",
    "type": "bidbuild"
  },
  {
    "categories": [],
    "name": "Bidsketch",
    "type": "bidsketch"
  },
  {
    "categories": [],
    "name": "Big Red Cloud",
    "type": "bigredcloud"
  },
  {
    "categories": [],
    "name": "BigBlueButton",
    "type": "bigbluebutton"
  },
  {
    "categories": [],
    "name": "Billetto",
    "type": "billetto"
  },
  {
    "categories": [],
    "name": "Billetweb",
    "type": "billetweb"
  },
  {
    "categories": [],
    "name": "Billfold",
    "type": "billfold"
  },
  {
    "categories": [],
    "name": "Billie",
    "type": "billie"
  },
  {
    "categories": [],
    "name": "Billplz",
    "type": "billplz"
  },
  {
    "categories": [],
    "name": "Binated",
    "type": "binated"
  },
  {
    "categories": [],
    "name": "Binderr",
    "type": "binderr"
  },
  {
    "categories": [],
    "name": "Biron",
    "type": "biron"
  },
  {
    "categories": [],
    "name": "BizMerlin",
    "type": "bizmerlin"
  },
  {
    "categories": [],
    "name": "Black Forest Labs FLUX",
    "type": "blackforestlabsflux"
  },
  {
    "categories": [],
    "name": "Blastable",
    "type": "blastable"
  },
  {
    "categories": [],
    "name": "Blink",
    "type": "blink"
  },
  {
    "categories": [],
    "name": "Blitz API",
    "type": "blitzapi"
  },
  {
    "categories": [],
    "name": "Blogger",
    "type": "blogger"
  },
  {
    "categories": [],
    "name": "Blume Global",
    "type": "blumeglobal"
  },
  {
    "categories": [],
    "name": "Canonical",
    "type": "canonical"
  },
  {
    "categories": [],
    "name": "CatchUp",
    "type": "catchup"
  },
  {
    "categories": [],
    "name": "Cayzu",
    "type": "cayzu"
  },
  {
    "categories": [],
    "name": "CE-Go",
    "type": "cego"
  },
  {
    "categories": [],
    "name": "Cellcast",
    "type": "cellcast"
  },
  {
    "categories": [],
    "name": "Centra",
    "type": "centra"
  },
  {
    "categories": [],
    "name": "CertSeal",
    "type": "certseal"
  },
  {
    "categories": [],
    "name": "CGTrader",
    "type": "cgtrader"
  },
  {
    "categories": [],
    "name": "Chameleon-i",
    "type": "chameleoni"
  },
  {
    "categories": [],
    "name": "ChannelRUSH",
    "type": "channelrush"
  },
  {
    "categories": [],
    "name": "Chargeblast",
    "type": "chargeblast"
  },
  {
    "categories": [],
    "name": "Chargeflow",
    "type": "chargeflow"
  },
  {
    "categories": [],
    "name": "Chartbrew",
    "type": "chartbrew"
  },
  {
    "categories": [],
    "name": "ChatBot",
    "type": "chatbot"
  },
  {
    "categories": [],
    "name": "Chatfuel",
    "type": "chatfuel"
  },
  {
    "categories": [],
    "name": "ChatKitty",
    "type": "chatkitty"
  },
  {
    "categories": [],
    "name": "Chatlayer",
    "type": "chatlayer"
  },
  {
    "categories": [],
    "name": "Chatsistant",
    "type": "chatsistant"
  },
  {
    "categories": [],
    "name": "Checkin.no",
    "type": "checkinno"
  },
  {
    "categories": [],
    "name": "Checkmob",
    "type": "checkmob"
  },
  {
    "categories": [],
    "name": "Cheddar",
    "type": "cheddar"
  },
  {
    "categories": [],
    "name": "Cheddar Up",
    "type": "cheddarup"
  },
  {
    "categories": [],
    "name": "Chronary",
    "type": "chronary"
  },
  {
    "categories": [],
    "name": "Cielo",
    "type": "cielo"
  },
  {
    "categories": [],
    "name": "CINC",
    "type": "cinc"
  },
  {
    "categories": [],
    "name": "Cincopa",
    "type": "cincopa"
  },
  {
    "categories": [],
    "name": "CINNOX",
    "type": "cinnox"
  },
  {
    "categories": [],
    "name": "Cirqll",
    "type": "cirqll"
  },
  {
    "categories": [],
    "name": "Cituro",
    "type": "cituro"
  },
  {
    "categories": [],
    "name": "CiviCRM",
    "type": "civicrm"
  },
  {
    "categories": [],
    "name": "Claim.MD",
    "type": "claimmd"
  },
  {
    "categories": [],
    "name": "Claisy",
    "type": "claisy"
  },
  {
    "categories": [],
    "name": "Clarifai",
    "type": "clarifai"
  },
  {
    "categories": [],
    "name": "Claris FileMaker",
    "type": "clarisfilemaker"
  },
  {
    "categories": [],
    "name": "Clarkup",
    "type": "clarkup"
  },
  {
    "categories": [],
    "name": "Clarra",
    "type": "clarra"
  },
  {
    "categories": [],
    "name": "ClassDo",
    "type": "classdo"
  },
  {
    "categories": [],
    "name": "Classe365",
    "type": "classe365"
  },
  {
    "categories": [],
    "name": "ClassMarker",
    "type": "classmarker"
  },
  {
    "categories": [],
    "name": "Clearout",
    "type": "clearout"
  },
  {
    "categories": [],
    "name": "ClearPolicy",
    "type": "clearpolicy"
  },
  {
    "categories": [],
    "name": "Clearstream",
    "type": "clearstream"
  },
  {
    "categories": [],
    "name": "Clever Cloud",
    "type": "clevercloud"
  },
  {
    "categories": [],
    "name": "Click2Mail",
    "type": "click2mail"
  },
  {
    "categories": [],
    "name": "ClickFunnels",
    "type": "clickfunnels"
  },
  {
    "categories": [],
    "name": "ClickTime",
    "type": "clicktime"
  },
  {
    "categories": [],
    "name": "Cliengo",
    "type": "cliengo"
  },
  {
    "categories": [],
    "name": "Climbo",
    "type": "climbo"
  },
  {
    "categories": [],
    "name": "Clinicos (PawthosX)",
    "type": "clinicospawthosx"
  },
  {
    "categories": [],
    "name": "Clip",
    "type": "clip"
  },
  {
    "categories": [],
    "name": "Clment",
    "type": "clment"
  },
  {
    "categories": [],
    "name": "CLOSUM",
    "type": "closum"
  },
  {
    "categories": [],
    "name": "Cloud 66",
    "type": "cloud66"
  },
  {
    "categories": [],
    "name": "CloudBlue Connect",
    "type": "cloudblueconnect"
  },
  {
    "categories": [],
    "name": "Cloudflare",
    "type": "cloudflare"
  },
  {
    "categories": [],
    "name": "Cloze",
    "type": "cloze"
  },
  {
    "categories": [],
    "name": "Clubplanner",
    "type": "clubplanner"
  },
  {
    "categories": [],
    "name": "ClubWorx",
    "type": "clubworx"
  },
  {
    "categories": [],
    "name": "Clutch",
    "type": "clutch"
  },
  {
    "categories": [],
    "name": "CM.com",
    "type": "cmcom"
  },
  {
    "categories": [],
    "name": "Coachful",
    "type": "coachful"
  },
  {
    "categories": [],
    "name": "Coassemble",
    "type": "coassemble"
  },
  {
    "categories": [],
    "name": "Cobot",
    "type": "cobot"
  },
  {
    "categories": [],
    "name": "CodeGPT",
    "type": "codegpt"
  },
  {
    "categories": [],
    "name": "Codehooks",
    "type": "codehooks"
  },
  {
    "categories": [],
    "name": "Coinremitter",
    "type": "coinremitter"
  },
  {
    "categories": [],
    "name": "ColdIQ",
    "type": "coldiq"
  },
  {
    "categories": [],
    "name": "Collected Notes",
    "type": "collectednotes"
  },
  {
    "categories": [],
    "name": "Color Me Shop",
    "type": "colormeshop"
  },
  {
    "categories": [],
    "name": "Cometly",
    "type": "cometly"
  },
  {
    "categories": [],
    "name": "CommissionCrowd",
    "type": "commissioncrowd"
  },
  {
    "categories": [],
    "name": "Commmune",
    "type": "commmune"
  },
  {
    "categories": [],
    "name": "CommPeak",
    "type": "commpeak"
  },
  {
    "categories": [],
    "name": "CompanyProof",
    "type": "companyproof"
  },
  {
    "categories": [],
    "name": "Complete Criminal Checks",
    "type": "completecriminalchecks"
  },
  {
    "categories": [],
    "name": "Computop",
    "type": "computop"
  },
  {
    "categories": [],
    "name": "Concord",
    "type": "concord"
  },
  {
    "categories": [],
    "name": "Confetti",
    "type": "confetti"
  },
  {
    "categories": [],
    "name": "ConnectyCube",
    "type": "connectycube"
  },
  {
    "categories": [],
    "name": "ConnexPay",
    "type": "connexpay"
  },
  {
    "categories": [],
    "name": "Contaqt",
    "type": "contaqt"
  },
  {
    "categories": [],
    "name": "Contextual AI",
    "type": "contextualai"
  },
  {
    "categories": [],
    "name": "Contlo",
    "type": "contlo"
  },
  {
    "categories": [],
    "name": "Conturs",
    "type": "conturs"
  },
  {
    "categories": [],
    "name": "Convai",
    "type": "convai"
  },
  {
    "categories": [],
    "name": "Convex",
    "type": "convex"
  },
  {
    "categories": [],
    "name": "Convirza",
    "type": "convirza"
  },
  {
    "categories": [],
    "name": "Convoflo",
    "type": "convoflo"
  },
  {
    "categories": [],
    "name": "Coolify",
    "type": "coolify"
  },
  {
    "categories": [],
    "name": "Cooperto",
    "type": "cooperto"
  },
  {
    "categories": [],
    "name": "CoordinateHQ",
    "type": "coordinatehq"
  },
  {
    "categories": [],
    "name": "Copperx",
    "type": "copperx"
  },
  {
    "categories": [],
    "name": "CoreCampus",
    "type": "corecampus"
  },
  {
    "categories": [],
    "name": "Correios",
    "type": "correios"
  },
  {
    "categories": [],
    "name": "Corsizio",
    "type": "corsizio"
  },
  {
    "categories": [],
    "name": "Cosmic",
    "type": "cosmic"
  },
  {
    "categories": [],
    "name": "CosVoice",
    "type": "cosvoice"
  },
  {
    "categories": [],
    "name": "CounselMore",
    "type": "counselmore"
  },
  {
    "categories": [],
    "name": "Count",
    "type": "count"
  },
  {
    "categories": [],
    "name": "Countly",
    "type": "countly"
  },
  {
    "categories": [],
    "name": "Coupontools",
    "type": "coupontools"
  },
  {
    "categories": [],
    "name": "Coursesight",
    "type": "coursesight"
  },
  {
    "categories": [],
    "name": "Coviu",
    "type": "coviu"
  },
  {
    "categories": [],
    "name": "CPFHub",
    "type": "cpfhub"
  },
  {
    "categories": [],
    "name": "Craftboxx",
    "type": "craftboxx"
  },
  {
    "categories": [],
    "name": "Craftgate",
    "type": "craftgate"
  },
  {
    "categories": [],
    "name": "Cratejoy",
    "type": "cratejoy"
  },
  {
    "categories": [],
    "name": "Credas",
    "type": "credas"
  },
  {
    "categories": [],
    "name": "Crescendo Lab CAAC",
    "type": "crescendolabcaac"
  },
  {
    "categories": [],
    "name": "CrewTraka",
    "type": "crewtraka"
  },
  {
    "categories": [],
    "name": "Crowdsignal",
    "type": "crowdsignal"
  },
  {
    "categories": [],
    "name": "Cruise Control",
    "type": "cruisecontrol"
  },
  {
    "categories": [],
    "name": "Cruisen",
    "type": "cruisen"
  },
  {
    "categories": [],
    "name": "CryptAPI",
    "type": "cryptapi"
  },
  {
    "categories": [],
    "name": "CS-Cart",
    "type": "cscart"
  },
  {
    "categories": [],
    "name": "Cube",
    "type": "cube"
  },
  {
    "categories": [],
    "name": "CUDO Compute",
    "type": "cudocompute"
  },
  {
    "categories": [],
    "name": "Cuentica",
    "type": "cuentica"
  },
  {
    "categories": [],
    "name": "Curfex",
    "type": "curfex"
  },
  {
    "categories": [],
    "name": "Currency Alliance",
    "type": "currencyalliance"
  },
  {
    "categories": [],
    "name": "Custify",
    "type": "custify"
  },
  {
    "categories": [],
    "name": "Customer.guru",
    "type": "customerguru"
  },
  {
    "categories": [],
    "name": "CustomerBase",
    "type": "customerbase"
  },
  {
    "categories": [],
    "name": "Cvent",
    "type": "cvent"
  },
  {
    "categories": [],
    "name": "CViewSurvey",
    "type": "cviewsurvey"
  },
  {
    "categories": [],
    "name": "CVR API",
    "type": "cvrapi"
  },
  {
    "categories": [],
    "name": "Cyberimpact",
    "type": "cyberimpact"
  },
  {
    "categories": [],
    "name": "Cyfe",
    "type": "cyfe"
  },
  {
    "categories": [],
    "name": "Cynthia AI",
    "type": "cynthiaai"
  },
  {
    "categories": [],
    "name": "D7 Networks",
    "type": "d7networks"
  },
  {
    "categories": [],
    "name": "Dabra",
    "type": "dabra"
  },
  {
    "categories": [],
    "name": "Daktela",
    "type": "daktela"
  },
  {
    "categories": [],
    "name": "Dalenys",
    "type": "dalenys"
  },
  {
    "categories": [],
    "name": "Datto Autotask PSA",
    "type": "dattoautotaskpsa"
  },
  {
    "categories": [],
    "name": "Decidento",
    "type": "decidento"
  },
  {
    "categories": [],
    "name": "Deel: add ATS category to existing integration",
    "type": "deeladdatscategorytoexistingintegration"
  },
  {
    "categories": [],
    "name": "Deskbird",
    "type": "deskbird"
  },
  {
    "categories": [],
    "name": "Devopness",
    "type": "devopness"
  },
  {
    "categories": [],
    "name": "DHL eCommerce Benelux",
    "type": "dhlecommercebenelux"
  },
  {
    "categories": [],
    "name": "DigitalRecruiters (Cegid)",
    "type": "digitalrecruiterscegid"
  },
  {
    "categories": [],
    "name": "dilisense",
    "type": "dilisense"
  },
  {
    "categories": [],
    "name": "DocSpring",
    "type": "docspring"
  },
  {
    "categories": [],
    "name": "Double",
    "type": "double"
  },
  {
    "categories": [],
    "name": "DoubleTick",
    "type": "doubletick"
  },
  {
    "categories": [],
    "name": "Dow Jones Risk & Compliance",
    "type": "dowjonesriskcompliance"
  },
  {
    "categories": [],
    "name": "Dual-use defense, phase 2: new defense-specific integrations (umbrella)",
    "type": "dualusedefensephase2newdefensespecificintegrationsumbrella"
  },
  {
    "categories": [],
    "name": "DusuPay",
    "type": "dusupay"
  },
  {
    "categories": [],
    "name": "Dux-Soup",
    "type": "duxsoup"
  },
  {
    "categories": [],
    "name": "Dynosend",
    "type": "dynosend"
  },
  {
    "categories": [],
    "name": "Dyte",
    "type": "dyte"
  },
  {
    "categories": [],
    "name": "E-cinch",
    "type": "ecinch"
  },
  {
    "categories": [],
    "name": "E2open",
    "type": "e2open"
  },
  {
    "categories": [],
    "name": "e2open TMS",
    "type": "e2opentms"
  },
  {
    "categories": [],
    "name": "Easybizy",
    "type": "easybizy"
  },
  {
    "categories": [],
    "name": "EasyFill.ai",
    "type": "easyfillai"
  },
  {
    "categories": [],
    "name": "EasyRoutes",
    "type": "easyroutes"
  },
  {
    "categories": [],
    "name": "Ebury",
    "type": "ebury"
  },
  {
    "categories": [],
    "name": "EchelonPay",
    "type": "echelonpay"
  },
  {
    "categories": [],
    "name": "echowin",
    "type": "echowin"
  },
  {
    "categories": [],
    "name": "ECOMMPAY",
    "type": "ecommpay"
  },
  {
    "categories": [],
    "name": "Edgegap",
    "type": "edgegap"
  },
  {
    "categories": [],
    "name": "Ediware",
    "type": "ediware"
  },
  {
    "categories": [],
    "name": "EDluminate",
    "type": "edluminate"
  },
  {
    "categories": [],
    "name": "edoobox",
    "type": "edoobox"
  },
  {
    "categories": [],
    "name": "EduChecker",
    "type": "educhecker"
  },
  {
    "categories": [],
    "name": "Edusign",
    "type": "edusign"
  },
  {
    "categories": [],
    "name": "Eduzz",
    "type": "eduzz"
  },
  {
    "categories": [],
    "name": "Ekklo",
    "type": "ekklo"
  },
  {
    "categories": [],
    "name": "Elai",
    "type": "elai"
  },
  {
    "categories": [],
    "name": "Elite Funnels",
    "type": "elitefunnels"
  },
  {
    "categories": [],
    "name": "Ellipsend",
    "type": "ellipsend"
  },
  {
    "categories": [],
    "name": "EmailLabs",
    "type": "emaillabs"
  },
  {
    "categories": [],
    "name": "Encharge",
    "type": "encharge"
  },
  {
    "categories": [],
    "name": "Endear",
    "type": "endear"
  },
  {
    "categories": [],
    "name": "EndorseFlow",
    "type": "endorseflow"
  },
  {
    "categories": [],
    "name": "Engagespot",
    "type": "engagespot"
  },
  {
    "categories": [],
    "name": "EngineRoom",
    "type": "engineroom"
  },
  {
    "categories": [],
    "name": "Enigma",
    "type": "enigma"
  },
  {
    "categories": [],
    "name": "Enquiry Tracker",
    "type": "enquirytracker"
  },
  {
    "categories": [],
    "name": "Enrichley",
    "type": "enrichley"
  },
  {
    "categories": [],
    "name": "Enrow",
    "type": "enrow"
  },
  {
    "categories": [],
    "name": "Envoice",
    "type": "envoice"
  },
  {
    "categories": [],
    "name": "Envoy",
    "type": "envoy"
  },
  {
    "categories": [],
    "name": "Escrow.com",
    "type": "escrowcom"
  },
  {
    "categories": [],
    "name": "eSewa",
    "type": "esewa"
  },
  {
    "categories": [],
    "name": "eSignaBox",
    "type": "esignabox"
  },
  {
    "categories": [],
    "name": "Esri ArcGIS (Online + Enterprise)",
    "type": "esriarcgisonlineenterprise"
  },
  {
    "categories": [],
    "name": "Estimate Rocket",
    "type": "estimaterocket"
  },
  {
    "categories": [],
    "name": "Etrigue",
    "type": "etrigue"
  },
  {
    "categories": [],
    "name": "Evaboot",
    "type": "evaboot"
  },
  {
    "categories": [],
    "name": "Event Planon",
    "type": "eventplanon"
  },
  {
    "categories": [],
    "name": "Eventee",
    "type": "eventee"
  },
  {
    "categories": [],
    "name": "Eventleaf",
    "type": "eventleaf"
  },
  {
    "categories": [],
    "name": "Eventmaker",
    "type": "eventmaker"
  },
  {
    "categories": [],
    "name": "EventMobi",
    "type": "eventmobi"
  },
  {
    "categories": [],
    "name": "Eventscase",
    "type": "eventscase"
  },
  {
    "categories": [],
    "name": "Everfit",
    "type": "everfit"
  },
  {
    "categories": [],
    "name": "Everflow",
    "type": "everflow"
  },
  {
    "categories": [],
    "name": "Everhour",
    "type": "everhour"
  },
  {
    "categories": [],
    "name": "Everpop",
    "type": "everpop"
  },
  {
    "categories": [],
    "name": "Eversend",
    "type": "eversend"
  },
  {
    "categories": [],
    "name": "EveryPage",
    "type": "everypage"
  },
  {
    "categories": [],
    "name": "Evolio",
    "type": "evolio"
  },
  {
    "categories": [],
    "name": "ExhibitDay",
    "type": "exhibitday"
  },
  {
    "categories": [],
    "name": "Extensis Portfolio",
    "type": "extensisportfolio"
  },
  {
    "categories": [],
    "name": "Extensiv Order Manager",
    "type": "extensivordermanager"
  },
  {
    "categories": [],
    "name": "Eyefinity",
    "type": "eyefinity"
  },
  {
    "categories": [],
    "name": "EZ File Drop",
    "type": "ezfiledrop"
  },
  {
    "categories": [],
    "name": "EziDox",
    "type": "ezidox"
  },
  {
    "categories": [],
    "name": "Ezus",
    "type": "ezus"
  },
  {
    "categories": [],
    "name": "FacilityBot",
    "type": "facilitybot"
  },
  {
    "categories": [],
    "name": "Faktoora",
    "type": "faktoora"
  },
  {
    "categories": [],
    "name": "FALAI Atendimento",
    "type": "falaiatendimento"
  },
  {
    "categories": [],
    "name": "Faraday",
    "type": "faraday"
  },
  {
    "categories": [],
    "name": "FareHarbor",
    "type": "fareharbor"
  },
  {
    "categories": [],
    "name": "Fashion Cloud",
    "type": "fashioncloud"
  },
  {
    "categories": [],
    "name": "FASHN",
    "type": "fashn"
  },
  {
    "categories": [],
    "name": "FastSpring",
    "type": "fastspring"
  },
  {
    "categories": [],
    "name": "Favro",
    "type": "favro"
  },
  {
    "categories": [],
    "name": "FawryPay",
    "type": "fawrypay"
  },
  {
    "categories": [],
    "name": "Featurebase",
    "type": "featurebase"
  },
  {
    "categories": [],
    "name": "Feedback by Marmeto",
    "type": "feedbackbymarmeto"
  },
  {
    "categories": [],
    "name": "FeedBlitz",
    "type": "feedblitz"
  },
  {
    "categories": [],
    "name": "Feedier",
    "type": "feedier"
  },
  {
    "categories": [],
    "name": "Fera",
    "type": "fera"
  },
  {
    "categories": [],
    "name": "FieldAware",
    "type": "fieldaware"
  },
  {
    "categories": [],
    "name": "Filebase",
    "type": "filebase"
  },
  {
    "categories": [],
    "name": "Filepass",
    "type": "filepass"
  },
  {
    "categories": [],
    "name": "Filerobot",
    "type": "filerobot"
  },
  {
    "categories": [],
    "name": "FileRun",
    "type": "filerun"
  },
  {
    "categories": [],
    "name": "Finicity",
    "type": "finicity"
  },
  {
    "categories": [],
    "name": "Firebase Hosting",
    "type": "firebasehosting"
  },
  {
    "categories": [],
    "name": "Firmenwatch",
    "type": "firmenwatch"
  },
  {
    "categories": [],
    "name": "Firmwater LMS",
    "type": "firmwaterlms"
  },
  {
    "categories": [],
    "name": "Fitbit Plus",
    "type": "fitbitplus"
  },
  {
    "categories": [],
    "name": "Flexopus",
    "type": "flexopus"
  },
  {
    "categories": [],
    "name": "Fliki",
    "type": "fliki"
  },
  {
    "categories": [],
    "name": "Flipdish",
    "type": "flipdish"
  },
  {
    "categories": [],
    "name": "Flock",
    "type": "flock"
  },
  {
    "categories": [],
    "name": "flow.team",
    "type": "flowteam"
  },
  {
    "categories": [],
    "name": "Flowdash",
    "type": "flowdash"
  },
  {
    "categories": [],
    "name": "FlowFast",
    "type": "flowfast"
  },
  {
    "categories": [],
    "name": "Flowral",
    "type": "flowral"
  },
  {
    "categories": [],
    "name": "Flowroute",
    "type": "flowroute"
  },
  {
    "categories": [],
    "name": "Flutterwave",
    "type": "flutterwave"
  },
  {
    "categories": [],
    "name": "Force24",
    "type": "force24"
  },
  {
    "categories": [],
    "name": "Formbricks",
    "type": "formbricks"
  },
  {
    "categories": [],
    "name": "Formcarry",
    "type": "formcarry"
  },
  {
    "categories": [],
    "name": "FrankieOne",
    "type": "frankieone"
  },
  {
    "categories": [],
    "name": "Fructu",
    "type": "fructu"
  },
  {
    "categories": [],
    "name": "Fulcrum",
    "type": "fulcrum"
  },
  {
    "categories": [],
    "name": "Fulfillment.com",
    "type": "fulfillmentcom"
  },
  {
    "categories": [],
    "name": "Fundz",
    "type": "fundz"
  },
  {
    "categories": [],
    "name": "FusionAuth",
    "type": "fusionauth"
  },
  {
    "categories": [],
    "name": "Future Fulfilment",
    "type": "futurefulfilment"
  },
  {
    "categories": [],
    "name": "FuzeRx",
    "type": "fuzerx"
  },
  {
    "categories": [],
    "name": "FuzeRx (Truepill)",
    "type": "fuzerxtruepill"
  },
  {
    "categories": [],
    "name": "fynk",
    "type": "fynk"
  },
  {
    "categories": [],
    "name": "G2",
    "type": "g2"
  },
  {
    "categories": [],
    "name": "Gainsight Customer Communities",
    "type": "gainsightcustomercommunities"
  },
  {
    "categories": [],
    "name": "GameAnalytics",
    "type": "gameanalytics"
  },
  {
    "categories": [],
    "name": "Gcore",
    "type": "gcore"
  },
  {
    "categories": [],
    "name": "Geckoboard",
    "type": "geckoboard"
  },
  {
    "categories": [],
    "name": "Generix Invoicing Services",
    "type": "generixinvoicingservices"
  },
  {
    "categories": [],
    "name": "Genny by LOVO",
    "type": "gennybylovo"
  },
  {
    "categories": [],
    "name": "geoCapture",
    "type": "geocapture"
  },
  {
    "categories": [],
    "name": "GererMesAffaires",
    "type": "gerermesaffaires"
  },
  {
    "categories": [],
    "name": "Get a Newsletter",
    "type": "getanewsletter"
  },
  {
    "categories": [],
    "name": "Get Balance",
    "type": "getbalance"
  },
  {
    "categories": [],
    "name": "Getnet",
    "type": "getnet"
  },
  {
    "categories": [],
    "name": "Ghost",
    "type": "ghost"
  },
  {
    "categories": [],
    "name": "Glean.ly",
    "type": "gleanly"
  },
  {
    "categories": [],
    "name": "Glibl",
    "type": "glibl"
  },
  {
    "categories": [],
    "name": "Glide",
    "type": "glide"
  },
  {
    "categories": [],
    "name": "GlobalEntity API",
    "type": "globalentityapi"
  },
  {
    "categories": [],
    "name": "GLPI",
    "type": "glpi"
  },
  {
    "categories": [],
    "name": "GoFormz",
    "type": "goformz"
  },
  {
    "categories": [],
    "name": "Goody",
    "type": "goody"
  },
  {
    "categories": [],
    "name": "Google Bare Metal Solution",
    "type": "googlebaremetalsolution"
  },
  {
    "categories": [],
    "name": "Google Cloud Storage",
    "type": "googlecloudstorage"
  },
  {
    "categories": [],
    "name": "Google Keep",
    "type": "googlekeep"
  },
  {
    "categories": [],
    "name": "GoTo Connect Messaging",
    "type": "gotoconnectmessaging"
  },
  {
    "categories": [],
    "name": "GoTo Webinar & GoTo Training",
    "type": "gotowebinargototraining"
  },
  {
    "categories": [],
    "name": "GrowthHero",
    "type": "growthhero"
  },
  {
    "categories": [],
    "name": "Hatz AI",
    "type": "hatzai"
  },
  {
    "categories": [],
    "name": "Hedy",
    "type": "hedy"
  },
  {
    "categories": [],
    "name": "Heidi Health",
    "type": "heidihealth"
  },
  {
    "categories": [],
    "name": "Heights Platform",
    "type": "heightsplatform"
  },
  {
    "categories": [],
    "name": "HelloAsso",
    "type": "helloasso"
  },
  {
    "categories": [],
    "name": "hetras PMS",
    "type": "hetraspms"
  },
  {
    "categories": [],
    "name": "Hexfit",
    "type": "hexfit"
  },
  {
    "categories": [],
    "name": "HeyGen",
    "type": "heygen"
  },
  {
    "categories": [],
    "name": "Hiflow",
    "type": "hiflow"
  },
  {
    "categories": [],
    "name": "Higher Logic",
    "type": "higherlogic"
  },
  {
    "categories": [],
    "name": "Hilos",
    "type": "hilos"
  },
  {
    "categories": [],
    "name": "Hire.Inc",
    "type": "hireinc"
  },
  {
    "categories": [],
    "name": "Hivelight",
    "type": "hivelight"
  },
  {
    "categories": [],
    "name": "Hnry",
    "type": "hnry"
  },
  {
    "categories": [],
    "name": "Hourtick",
    "type": "hourtick"
  },
  {
    "categories": [],
    "name": "HrFlow.ai",
    "type": "hrflowai"
  },
  {
    "categories": [],
    "name": "Humanforce intelliHR",
    "type": "humanforceintellihr"
  },
  {
    "categories": [],
    "name": "Hume AI",
    "type": "humeai"
  },
  {
    "categories": [],
    "name": "Hyland Saperion",
    "type": "hylandsaperion"
  },
  {
    "categories": [],
    "name": "HyperPay",
    "type": "hyperpay"
  },
  {
    "categories": [],
    "name": "Hyperwallet",
    "type": "hyperwallet"
  },
  {
    "categories": [],
    "name": "Hyros",
    "type": "hyros"
  },
  {
    "categories": [],
    "name": "IBM Cloudant",
    "type": "ibmcloudant"
  },
  {
    "categories": [],
    "name": "IBM Maximo",
    "type": "ibmmaximo"
  },
  {
    "categories": [],
    "name": "IBM Watson Text to Speech",
    "type": "ibmwatsontexttospeech"
  },
  {
    "categories": [],
    "name": "iCatalogue",
    "type": "icatalogue"
  },
  {
    "categories": [],
    "name": "ID.me",
    "type": "idme"
  },
  {
    "categories": [],
    "name": "Ideogram",
    "type": "ideogram"
  },
  {
    "categories": [],
    "name": "Ideolve",
    "type": "ideolve"
  },
  {
    "categories": [],
    "name": "IDWise",
    "type": "idwise"
  },
  {
    "categories": [],
    "name": "iLovePDF Sign",
    "type": "ilovepdfsign"
  },
  {
    "categories": [],
    "name": "iMeetify",
    "type": "imeetify"
  },
  {
    "categories": [],
    "name": "Indicadores.ar",
    "type": "indicadoresar"
  },
  {
    "categories": [],
    "name": "IndiePitcher",
    "type": "indiepitcher"
  },
  {
    "categories": [],
    "name": "Infinity",
    "type": "infinity"
  },
  {
    "categories": [],
    "name": "Inflection AI",
    "type": "inflectionai"
  },
  {
    "categories": [],
    "name": "Inistate",
    "type": "inistate"
  },
  {
    "categories": [],
    "name": "inMobile",
    "type": "inmobile"
  },
  {
    "categories": [],
    "name": "Innoship",
    "type": "innoship"
  },
  {
    "categories": [],
    "name": "Interswitch",
    "type": "interswitch"
  },
  {
    "categories": [],
    "name": "interviewstream",
    "type": "interviewstream"
  },
  {
    "categories": [],
    "name": "Intralinks",
    "type": "intralinks"
  },
  {
    "categories": [],
    "name": "iQualify",
    "type": "iqualify"
  },
  {
    "categories": [],
    "name": "iSendPro",
    "type": "isendpro"
  },
  {
    "categories": [],
    "name": "iVvy",
    "type": "ivvy"
  },
  {
    "categories": [],
    "name": "iZooto",
    "type": "izooto"
  },
  {
    "categories": [],
    "name": "Jammed",
    "type": "jammed"
  },
  {
    "categories": [],
    "name": "JGID",
    "type": "jgid"
  },
  {
    "categories": [],
    "name": "Jina AI",
    "type": "jinaai"
  },
  {
    "categories": [],
    "name": "Joan (Visionect)",
    "type": "joanvisionect"
  },
  {
    "categories": [],
    "name": "JobBooker",
    "type": "jobbooker"
  },
  {
    "categories": [],
    "name": "Jodie",
    "type": "jodie"
  },
  {
    "categories": [],
    "name": "join.me",
    "type": "joinme"
  },
  {
    "categories": [],
    "name": "JuJu",
    "type": "juju"
  },
  {
    "categories": [],
    "name": "Jumppl",
    "type": "jumppl"
  },
  {
    "categories": [],
    "name": "Jumpseller",
    "type": "jumpseller"
  },
  {
    "categories": [],
    "name": "Jurny",
    "type": "jurny"
  },
  {
    "categories": [],
    "name": "Juspay",
    "type": "juspay"
  },
  {
    "categories": [],
    "name": "Juspronto",
    "type": "juspronto"
  },
  {
    "categories": [],
    "name": "Just Eat",
    "type": "justeat"
  },
  {
    "categories": [],
    "name": "JVZoo",
    "type": "jvzoo"
  },
  {
    "categories": [],
    "name": "JW Player",
    "type": "jwplayer"
  },
  {
    "categories": [],
    "name": "Kadence",
    "type": "kadence"
  },
  {
    "categories": [],
    "name": "Kandio",
    "type": "kandio"
  },
  {
    "categories": [],
    "name": "Karlia",
    "type": "karlia"
  },
  {
    "categories": [],
    "name": "Katana",
    "type": "katana"
  },
  {
    "categories": [],
    "name": "Keen",
    "type": "keen"
  },
  {
    "categories": [],
    "name": "Kiflo",
    "type": "kiflo"
  },
  {
    "categories": [],
    "name": "Kissflow",
    "type": "kissflow"
  },
  {
    "categories": [],
    "name": "Kiwify",
    "type": "kiwify"
  },
  {
    "categories": [],
    "name": "KlickTipp",
    "type": "klicktipp"
  },
  {
    "categories": [],
    "name": "Klingo",
    "type": "klingo"
  },
  {
    "categories": [],
    "name": "Kochava",
    "type": "kochava"
  },
  {
    "categories": [],
    "name": "koomalooma",
    "type": "koomalooma"
  },
  {
    "categories": [],
    "name": "Kourses",
    "type": "kourses"
  },
  {
    "categories": [],
    "name": "Krozu",
    "type": "krozu"
  },
  {
    "categories": [],
    "name": "Ksaar",
    "type": "ksaar"
  },
  {
    "categories": [],
    "name": "Kubflow",
    "type": "kubflow"
  },
  {
    "categories": [],
    "name": "Lambda Cloud",
    "type": "lambdacloud"
  },
  {
    "categories": [],
    "name": "Late",
    "type": "late"
  },
  {
    "categories": [],
    "name": "LazyAds",
    "type": "lazyads"
  },
  {
    "categories": [],
    "name": "LeafLink",
    "type": "leaflink"
  },
  {
    "categories": [],
    "name": "Leal",
    "type": "leal"
  },
  {
    "categories": [],
    "name": "Learnifier",
    "type": "learnifier"
  },
  {
    "categories": [],
    "name": "Legalesign",
    "type": "legalesign"
  },
  {
    "categories": [],
    "name": "Lemonway",
    "type": "lemonway"
  },
  {
    "categories": [],
    "name": "Leonardo.Ai",
    "type": "leonardoai"
  },
  {
    "categories": [],
    "name": "Let's Level Up",
    "type": "letslevelup"
  },
  {
    "categories": [],
    "name": "Lettermint",
    "type": "lettermint"
  },
  {
    "categories": [],
    "name": "Leverly",
    "type": "leverly"
  },
  {
    "categories": [],
    "name": "Lexamica",
    "type": "lexamica"
  },
  {
    "categories": [],
    "name": "Lexopulus",
    "type": "lexopulus"
  },
  {
    "categories": [],
    "name": "LEXZUR",
    "type": "lexzur"
  },
  {
    "categories": [],
    "name": "Liaison Spectrum EMP",
    "type": "liaisonspectrumemp"
  },
  {
    "categories": [],
    "name": "Limitguard",
    "type": "limitguard"
  },
  {
    "categories": [],
    "name": "ListingsAPI",
    "type": "listingsapi"
  },
  {
    "categories": [],
    "name": "Listnr",
    "type": "listnr"
  },
  {
    "categories": [],
    "name": "Livabl",
    "type": "livabl"
  },
  {
    "categories": [],
    "name": "Livestorm",
    "type": "livestorm"
  },
  {
    "categories": [],
    "name": "Lleida.net",
    "type": "lleidanet"
  },
  {
    "categories": [],
    "name": "LocalOps",
    "type": "localops"
  },
  {
    "categories": [],
    "name": "Localytics",
    "type": "localytics"
  },
  {
    "categories": [],
    "name": "Lofty",
    "type": "lofty"
  },
  {
    "categories": [],
    "name": "Loket.nl",
    "type": "loketnl"
  },
  {
    "categories": [],
    "name": "Loom",
    "type": "loom"
  },
  {
    "categories": [],
    "name": "Loop Returns",
    "type": "loopreturns"
  },
  {
    "categories": [],
    "name": "Loyalty Gator",
    "type": "loyaltygator"
  },
  {
    "categories": [],
    "name": "LoyaltyLion",
    "type": "loyaltylion"
  },
  {
    "categories": [],
    "name": "Loyalzoo",
    "type": "loyalzoo"
  },
  {
    "categories": [],
    "name": "LSArespond",
    "type": "lsarespond"
  },
  {
    "categories": [],
    "name": "Lula GAIL",
    "type": "lulagail"
  },
  {
    "categories": [],
    "name": "Luma",
    "type": "luma"
  },
  {
    "categories": [],
    "name": "Luma Dream Machine",
    "type": "lumadreammachine"
  },
  {
    "categories": [],
    "name": "Lumabill",
    "type": "lumabill"
  },
  {
    "categories": [],
    "name": "Lumenfall",
    "type": "lumenfall"
  },
  {
    "categories": [],
    "name": "Luminjo",
    "type": "luminjo"
  },
  {
    "categories": [],
    "name": "Lytho",
    "type": "lytho"
  },
  {
    "categories": [],
    "name": "M-Pesa Daraja",
    "type": "mpesadaraja"
  },
  {
    "categories": [],
    "name": "M-Pesa Ethiopia",
    "type": "mpesaethiopia"
  },
  {
    "categories": [],
    "name": "Macorva",
    "type": "macorva"
  },
  {
    "categories": [],
    "name": "Magic Hour",
    "type": "magichour"
  },
  {
    "categories": [],
    "name": "MagicBell",
    "type": "magicbell"
  },
  {
    "categories": [],
    "name": "MailGlyph",
    "type": "mailglyph"
  },
  {
    "categories": [],
    "name": "Mailjet",
    "type": "mailjet"
  },
  {
    "categories": [],
    "name": "Mails.ai",
    "type": "mailsai"
  },
  {
    "categories": [],
    "name": "MailSquad",
    "type": "mailsquad"
  },
  {
    "categories": [],
    "name": "Mailtrap",
    "type": "mailtrap"
  },
  {
    "categories": [],
    "name": "Maintenance Connection",
    "type": "maintenanceconnection"
  },
  {
    "categories": [],
    "name": "MakePlans",
    "type": "makeplans"
  },
  {
    "categories": [],
    "name": "Malga",
    "type": "malga"
  },
  {
    "categories": [],
    "name": "MandAPI",
    "type": "mandapi"
  },
  {
    "categories": [],
    "name": "Mandrill (Mailchimp Transactional)",
    "type": "mandrillmailchimptransactional"
  },
  {
    "categories": [],
    "name": "Manifestly Checklists",
    "type": "manifestlychecklists"
  },
  {
    "categories": [],
    "name": "Marlie AI",
    "type": "marlieai"
  },
  {
    "categories": [],
    "name": "MatchMates",
    "type": "matchmates"
  },
  {
    "categories": [],
    "name": "Mateo",
    "type": "mateo"
  },
  {
    "categories": [],
    "name": "Matrix (",
    "type": "matrix"
  },
  {
    "categories": [],
    "name": "Matrix Synapse",
    "type": "matrixsynapse"
  },
  {
    "categories": [],
    "name": "Mattermost",
    "type": "mattermost"
  },
  {
    "categories": [],
    "name": "Maysee",
    "type": "maysee"
  },
  {
    "categories": [],
    "name": "McTime",
    "type": "mctime"
  },
  {
    "categories": [],
    "name": "MediaSilo",
    "type": "mediasilo"
  },
  {
    "categories": [],
    "name": "Meet Xara",
    "type": "meetxara"
  },
  {
    "categories": [],
    "name": "Meet.bot",
    "type": "meetbot"
  },
  {
    "categories": [],
    "name": "Meetup",
    "type": "meetup"
  },
  {
    "categories": [],
    "name": "MegaAPI",
    "type": "megaapi"
  },
  {
    "categories": [],
    "name": "Megaventory",
    "type": "megaventory"
  },
  {
    "categories": [],
    "name": "Microsoft Sentinel",
    "type": "microsoftsentinel"
  },
  {
    "categories": [],
    "name": "Miho",
    "type": "miho"
  },
  {
    "categories": [],
    "name": "MIP",
    "type": "mip"
  },
  {
    "categories": [],
    "name": "Mitek Identity Cloud",
    "type": "mitekidentitycloud"
  },
  {
    "categories": [],
    "name": "Mitel CloudLink",
    "type": "mitelcloudlink"
  },
  {
    "categories": [],
    "name": "Mloflo",
    "type": "mloflo"
  },
  {
    "categories": [],
    "name": "ModelRunner",
    "type": "modelrunner"
  },
  {
    "categories": [],
    "name": "Moffin",
    "type": "moffin"
  },
  {
    "categories": [],
    "name": "Moka (MokaHR)",
    "type": "mokamokahr"
  },
  {
    "categories": [],
    "name": "MokaForm",
    "type": "mokaform"
  },
  {
    "categories": [],
    "name": "MoMo",
    "type": "momo"
  },
  {
    "categories": [],
    "name": "MoonClerk",
    "type": "moonclerk"
  },
  {
    "categories": [],
    "name": "MotionOps",
    "type": "motionops"
  },
  {
    "categories": [],
    "name": "Moxo",
    "type": "moxo"
  },
  {
    "categories": [],
    "name": "MusicGPT",
    "type": "musicgpt"
  },
  {
    "categories": [],
    "name": "myEZcare",
    "type": "myezcare"
  },
  {
    "categories": [],
    "name": "MyGadgetRepairs",
    "type": "mygadgetrepairs"
  },
  {
    "categories": [],
    "name": "MyTime",
    "type": "mytime"
  },
  {
    "categories": [],
    "name": "Nabla",
    "type": "nabla"
  },
  {
    "categories": [],
    "name": "Nagaris",
    "type": "nagaris"
  },
  {
    "categories": [],
    "name": "NameScan",
    "type": "namescan"
  },
  {
    "categories": [],
    "name": "NativeAds",
    "type": "nativeads"
  },
  {
    "categories": [],
    "name": "Navigatr",
    "type": "navigatr"
  },
  {
    "categories": [],
    "name": "Nedzo",
    "type": "nedzo"
  },
  {
    "categories": [],
    "name": "Nekst",
    "type": "nekst"
  },
  {
    "categories": [],
    "name": "NetRefer",
    "type": "netrefer"
  },
  {
    "categories": [],
    "name": "Nets",
    "type": "nets"
  },
  {
    "categories": [],
    "name": "Nets Data Suite",
    "type": "netsdatasuite"
  },
  {
    "categories": [],
    "name": "Networx",
    "type": "networx"
  },
  {
    "categories": [],
    "name": "Newbook",
    "type": "newbook"
  },
  {
    "categories": [],
    "name": "Newie",
    "type": "newie"
  },
  {
    "categories": [],
    "name": "Newt",
    "type": "newt"
  },
  {
    "categories": [],
    "name": "Nexi",
    "type": "nexi"
  },
  {
    "categories": [],
    "name": "Nexi XPay",
    "type": "nexixpay"
  },
  {
    "categories": [],
    "name": "NextAgency",
    "type": "nextagency"
  },
  {
    "categories": [],
    "name": "Nextdoor",
    "type": "nextdoor"
  },
  {
    "categories": [],
    "name": "NextEvent",
    "type": "nextevent"
  },
  {
    "categories": [],
    "name": "NextGen Office",
    "type": "nextgenoffice"
  },
  {
    "categories": [],
    "name": "Ninja Van",
    "type": "ninjavan"
  },
  {
    "categories": [],
    "name": "NinjaChat",
    "type": "ninjachat"
  },
  {
    "categories": [],
    "name": "Niubiz",
    "type": "niubiz"
  },
  {
    "categories": [],
    "name": "NLP Cloud",
    "type": "nlpcloud"
  },
  {
    "categories": [],
    "name": "nocnoc",
    "type": "nocnoc"
  },
  {
    "categories": [],
    "name": "nodaFi",
    "type": "nodafi"
  },
  {
    "categories": [],
    "name": "NoFrixion MoneyMoov",
    "type": "nofrixionmoneymoov"
  },
  {
    "categories": [],
    "name": "Noko",
    "type": "noko"
  },
  {
    "categories": [],
    "name": "Nomic",
    "type": "nomic"
  },
  {
    "categories": [],
    "name": "Nomod",
    "type": "nomod"
  },
  {
    "categories": [],
    "name": "Northbeam",
    "type": "northbeam"
  },
  {
    "categories": [],
    "name": "Northflank",
    "type": "northflank"
  },
  {
    "categories": [],
    "name": "Northpass",
    "type": "northpass"
  },
  {
    "categories": [],
    "name": "Not Diamond",
    "type": "notdiamond"
  },
  {
    "categories": [],
    "name": "NotaGuard",
    "type": "notaguard"
  },
  {
    "categories": [],
    "name": "NotePM",
    "type": "notepm"
  },
  {
    "categories": [],
    "name": "Notify",
    "type": "notify"
  },
  {
    "categories": [],
    "name": "Noty.ai",
    "type": "notyai"
  },
  {
    "categories": [],
    "name": "Novi AMS",
    "type": "noviams"
  },
  {
    "categories": [],
    "name": "NOWPayments",
    "type": "nowpayments"
  },
  {
    "categories": [],
    "name": "NTT DATA Payments",
    "type": "nttdatapayments"
  },
  {
    "categories": [],
    "name": "Nuapay",
    "type": "nuapay"
  },
  {
    "categories": [],
    "name": "Nuix",
    "type": "nuix"
  },
  {
    "categories": [],
    "name": "Numonic",
    "type": "numonic"
  },
  {
    "categories": [],
    "name": "NuPay for Business",
    "type": "nupayforbusiness"
  },
  {
    "categories": [],
    "name": "Nutribot",
    "type": "nutribot"
  },
  {
    "categories": [],
    "name": "NVIDIA Cloud Functions",
    "type": "nvidiacloudfunctions"
  },
  {
    "categories": [],
    "name": "Obat",
    "type": "obat"
  },
  {
    "categories": [],
    "name": "Objectionly",
    "type": "objectionly"
  },
  {
    "categories": [],
    "name": "obono",
    "type": "obono"
  },
  {
    "categories": [],
    "name": "Ocean by CognisantMD",
    "type": "oceanbycognisantmd"
  },
  {
    "categories": [],
    "name": "Ocoya",
    "type": "ocoya"
  },
  {
    "categories": [],
    "name": "Octanist",
    "type": "octanist"
  },
  {
    "categories": [],
    "name": "Octopi",
    "type": "octopi"
  },
  {
    "categories": [],
    "name": "ODK Central",
    "type": "odkcentral"
  },
  {
    "categories": [],
    "name": "Odnoklassniki (",
    "type": "odnoklassniki"
  },
  {
    "categories": [],
    "name": "OfferLab",
    "type": "offerlab"
  },
  {
    "categories": [],
    "name": "Officient",
    "type": "officient"
  },
  {
    "categories": [],
    "name": "Olivya",
    "type": "olivya"
  },
  {
    "categories": [],
    "name": "OLX",
    "type": "olx"
  },
  {
    "categories": [],
    "name": "Omise",
    "type": "omise"
  },
  {
    "categories": [],
    "name": "Omnivery",
    "type": "omnivery"
  },
  {
    "categories": [],
    "name": "ON24",
    "type": "on24"
  },
  {
    "categories": [],
    "name": "OneAdvanced Adastra",
    "type": "oneadvancedadastra"
  },
  {
    "categories": [],
    "name": "OneBrick",
    "type": "onebrick"
  },
  {
    "categories": [],
    "name": "OneSource Virtual",
    "type": "onesourcevirtual"
  },
  {
    "categories": [],
    "name": "Ongoing WMS",
    "type": "ongoingwms"
  },
  {
    "categories": [],
    "name": "OnlineXpress",
    "type": "onlinexpress"
  },
  {
    "categories": [],
    "name": "Ontraccr",
    "type": "ontraccr"
  },
  {
    "categories": [],
    "name": "Onurix",
    "type": "onurix"
  },
  {
    "categories": [],
    "name": "Open Health Hub",
    "type": "openhealthhub"
  },
  {
    "categories": [],
    "name": "OpenChannel",
    "type": "openchannel"
  },
  {
    "categories": [],
    "name": "OpenCorporates",
    "type": "opencorporates"
  },
  {
    "categories": [],
    "name": "Openpay",
    "type": "openpay"
  },
  {
    "categories": [],
    "name": "OpenPayd",
    "type": "openpayd"
  },
  {
    "categories": [],
    "name": "OpenSanctions",
    "type": "opensanctions"
  },
  {
    "categories": [],
    "name": "OpnForm",
    "type": "opnform"
  },
  {
    "categories": [],
    "name": "Opsgenie",
    "type": "opsgenie"
  },
  {
    "categories": [],
    "name": "Opteo",
    "type": "opteo"
  },
  {
    "categories": [],
    "name": "Optmyzr",
    "type": "optmyzr"
  },
  {
    "categories": [],
    "name": "Oracle Eloqua",
    "type": "oracleeloqua"
  },
  {
    "categories": [],
    "name": "Orca Scan",
    "type": "orcascan"
  },
  {
    "categories": [],
    "name": "Orchestra",
    "type": "orchestra"
  },
  {
    "categories": [],
    "name": "Ordavia",
    "type": "ordavia"
  },
  {
    "categories": [],
    "name": "Orderful",
    "type": "orderful"
  },
  {
    "categories": [],
    "name": "OrderOut",
    "type": "orderout"
  },
  {
    "categories": [],
    "name": "orq.ai",
    "type": "orqai"
  },
  {
    "categories": [],
    "name": "Orsay AI",
    "type": "orsayai"
  },
  {
    "categories": [],
    "name": "Orthanc",
    "type": "orthanc"
  },
  {
    "categories": [],
    "name": "OTOBO",
    "type": "otobo"
  },
  {
    "categories": [],
    "name": "Otter Waiver",
    "type": "otterwaiver"
  },
  {
    "categories": [],
    "name": "OtterText",
    "type": "ottertext"
  },
  {
    "categories": [],
    "name": "Outlign",
    "type": "outlign"
  },
  {
    "categories": [],
    "name": "OutreachAgent",
    "type": "outreachagent"
  },
  {
    "categories": [],
    "name": "OutReachBin",
    "type": "outreachbin"
  },
  {
    "categories": [],
    "name": "Oveit",
    "type": "oveit"
  },
  {
    "categories": [],
    "name": "Owler",
    "type": "owler"
  },
  {
    "categories": [],
    "name": "Owllee",
    "type": "owllee"
  },
  {
    "categories": [],
    "name": "Oystehr",
    "type": "oystehr"
  },
  {
    "categories": [],
    "name": "Paga",
    "type": "paga"
  },
  {
    "categories": [],
    "name": "PagerTree",
    "type": "pagertree"
  },
  {
    "categories": [],
    "name": "Paigo",
    "type": "paigo"
  },
  {
    "categories": [],
    "name": "Panopto",
    "type": "panopto"
  },
  {
    "categories": [],
    "name": "Paperspace",
    "type": "paperspace"
  },
  {
    "categories": [],
    "name": "Pappers",
    "type": "pappers"
  },
  {
    "categories": [],
    "name": "Papra",
    "type": "papra"
  },
  {
    "categories": [],
    "name": "Papyrs",
    "type": "papyrs"
  },
  {
    "categories": [],
    "name": "Parallel",
    "type": "parallel"
  },
  {
    "categories": [],
    "name": "ParcelParcel",
    "type": "parcelparcel"
  },
  {
    "categories": [],
    "name": "Parim",
    "type": "parim"
  },
  {
    "categories": [],
    "name": "Partial.ly",
    "type": "partially"
  },
  {
    "categories": [],
    "name": "Partnerize",
    "type": "partnerize"
  },
  {
    "categories": [],
    "name": "Patreon",
    "type": "patreon"
  },
  {
    "categories": [],
    "name": "pawaPay",
    "type": "pawapay"
  },
  {
    "categories": [],
    "name": "Pay.nl",
    "type": "paynl"
  },
  {
    "categories": [],
    "name": "payabl.",
    "type": "payabl"
  },
  {
    "categories": [],
    "name": "Payabli",
    "type": "payabli"
  },
  {
    "categories": [],
    "name": "PayArk",
    "type": "payark"
  },
  {
    "categories": [],
    "name": "PayDunya",
    "type": "paydunya"
  },
  {
    "categories": [],
    "name": "Payhip",
    "type": "payhip"
  },
  {
    "categories": [],
    "name": "Paylands",
    "type": "paylands"
  },
  {
    "categories": [],
    "name": "Payload CMS",
    "type": "payloadcms"
  },
  {
    "categories": [],
    "name": "PaymentsOS",
    "type": "paymentsos"
  },
  {
    "categories": [],
    "name": "PayMongo",
    "type": "paymongo"
  },
  {
    "categories": [],
    "name": "Paynow",
    "type": "paynow"
  },
  {
    "categories": [],
    "name": "PAYONE",
    "type": "payone"
  },
  {
    "categories": [],
    "name": "Payoneer",
    "type": "payoneer"
  },
  {
    "categories": [],
    "name": "PayPhone",
    "type": "payphone"
  },
  {
    "categories": [],
    "name": "PayPlug",
    "type": "payplug"
  },
  {
    "categories": [],
    "name": "PayRetailers",
    "type": "payretailers"
  },
  {
    "categories": [],
    "name": "PayRun.io",
    "type": "payrunio"
  },
  {
    "categories": [],
    "name": "Paysend",
    "type": "paysend"
  },
  {
    "categories": [],
    "name": "Paystack",
    "type": "paystack"
  },
  {
    "categories": [],
    "name": "PayTR",
    "type": "paytr"
  },
  {
    "categories": [],
    "name": "Paytrail",
    "type": "paytrail"
  },
  {
    "categories": [],
    "name": "PayU Latam",
    "type": "payulatam"
  },
  {
    "categories": [],
    "name": "pCloud",
    "type": "pcloud"
  },
  {
    "categories": [],
    "name": "Peach Payments",
    "type": "peachpayments"
  },
  {
    "categories": [],
    "name": "Peerbie",
    "type": "peerbie"
  },
  {
    "categories": [],
    "name": "Peerdom",
    "type": "peerdom"
  },
  {
    "categories": [],
    "name": "PeopleFinders Pro",
    "type": "peoplefinderspro"
  },
  {
    "categories": [],
    "name": "PingOne Advanced Identity Cloud",
    "type": "pingoneadvancedidentitycloud"
  },
  {
    "categories": [],
    "name": "Pluuug",
    "type": "pluuug"
  },
  {
    "categories": [],
    "name": "Portkey",
    "type": "portkey"
  },
  {
    "categories": [],
    "name": "Prioritio",
    "type": "prioritio"
  },
  {
    "categories": [],
    "name": "Priority ERP",
    "type": "priorityerp"
  },
  {
    "categories": [],
    "name": "ProctorExam",
    "type": "proctorexam"
  },
  {
    "categories": [],
    "name": "Procurify",
    "type": "procurify"
  },
  {
    "categories": [],
    "name": "Prodigi",
    "type": "prodigi"
  },
  {
    "categories": [],
    "name": "Proovid",
    "type": "proovid"
  },
  {
    "categories": [],
    "name": "Prosp",
    "type": "prosp"
  },
  {
    "categories": [],
    "name": "Provet Cloud",
    "type": "provetcloud"
  },
  {
    "categories": [],
    "name": "Proxmox VE",
    "type": "proxmoxve"
  },
  {
    "categories": [],
    "name": "Przelewy24",
    "type": "przelewy24"
  },
  {
    "categories": [],
    "name": "PTC Windchill",
    "type": "ptcwindchill"
  },
  {
    "categories": [],
    "name": "Publora",
    "type": "publora"
  },
  {
    "categories": [],
    "name": "PubNub",
    "type": "pubnub"
  },
  {
    "categories": [],
    "name": "Pulze.ai",
    "type": "pulzeai"
  },
  {
    "categories": [],
    "name": "Pydio Cells",
    "type": "pydiocells"
  },
  {
    "categories": [],
    "name": "PythonAnywhere",
    "type": "pythonanywhere"
  },
  {
    "categories": [],
    "name": "Qawafil",
    "type": "qawafil"
  },
  {
    "categories": [],
    "name": "Qoyod",
    "type": "qoyod"
  },
  {
    "categories": [],
    "name": "QRIS Interactive",
    "type": "qrisinteractive"
  },
  {
    "categories": [],
    "name": "Qualified",
    "type": "qualified"
  },
  {
    "categories": [],
    "name": "Qualiobee",
    "type": "qualiobee"
  },
  {
    "categories": [],
    "name": "Quandoo",
    "type": "quandoo"
  },
  {
    "categories": [],
    "name": "Quickbase",
    "type": "quickbase"
  },
  {
    "categories": [],
    "name": "QuickCity",
    "type": "quickcity"
  },
  {
    "categories": [],
    "name": "QuickClick",
    "type": "quickclick"
  },
  {
    "categories": [],
    "name": "QuickSchools",
    "type": "quickschools"
  },
  {
    "categories": [],
    "name": "QuickSend",
    "type": "quicksend"
  },
  {
    "categories": [],
    "name": "Quickteller",
    "type": "quickteller"
  },
  {
    "categories": [],
    "name": "Quizell",
    "type": "quizell"
  },
  {
    "categories": [],
    "name": "QuoteCam",
    "type": "quotecam"
  },
  {
    "categories": [],
    "name": "RAIDLOG",
    "type": "raidlog"
  },
  {
    "categories": [],
    "name": "Rappi",
    "type": "rappi"
  },
  {
    "categories": [],
    "name": "rasa.io",
    "type": "rasaio"
  },
  {
    "categories": [],
    "name": "Rasayel",
    "type": "rasayel"
  },
  {
    "categories": [],
    "name": "RateMyAgent",
    "type": "ratemyagent"
  },
  {
    "categories": [],
    "name": "Re-Leased",
    "type": "released"
  },
  {
    "categories": [],
    "name": "Reachinbox",
    "type": "reachinbox"
  },
  {
    "categories": [],
    "name": "Real Geeks",
    "type": "realgeeks"
  },
  {
    "categories": [],
    "name": "Realeflow",
    "type": "realeflow"
  },
  {
    "categories": [],
    "name": "RealPage",
    "type": "realpage"
  },
  {
    "categories": [],
    "name": "RealScout",
    "type": "realscout"
  },
  {
    "categories": [],
    "name": "Reassign",
    "type": "reassign"
  },
  {
    "categories": [],
    "name": "RecruitBPM",
    "type": "recruitbpm"
  },
  {
    "categories": [],
    "name": "Recruitis",
    "type": "recruitis"
  },
  {
    "categories": [],
    "name": "Redash",
    "type": "redash"
  },
  {
    "categories": [],
    "name": "Redeal",
    "type": "redeal"
  },
  {
    "categories": [],
    "name": "Rednote",
    "type": "rednote"
  },
  {
    "categories": [],
    "name": "Referly",
    "type": "referly"
  },
  {
    "categories": [],
    "name": "ReferralCandy",
    "type": "referralcandy"
  },
  {
    "categories": [],
    "name": "Referrizer",
    "type": "referrizer"
  },
  {
    "categories": [],
    "name": "Refersion",
    "type": "refersion"
  },
  {
    "categories": [],
    "name": "Regiondo",
    "type": "regiondo"
  },
  {
    "categories": [],
    "name": "Registrum",
    "type": "registrum"
  },
  {
    "categories": [],
    "name": "Reka",
    "type": "reka"
  },
  {
    "categories": [],
    "name": "Relatel",
    "type": "relatel"
  },
  {
    "categories": [],
    "name": "Reloadify",
    "type": "reloadify"
  },
  {
    "categories": [],
    "name": "Remember The Milk",
    "type": "rememberthemilk"
  },
  {
    "categories": [],
    "name": "Remindlo",
    "type": "remindlo"
  },
  {
    "categories": [],
    "name": "Remo",
    "type": "remo"
  },
  {
    "categories": [],
    "name": "Replify.ai",
    "type": "replifyai"
  },
  {
    "categories": [],
    "name": "Replit",
    "type": "replit"
  },
  {
    "categories": [],
    "name": "Reply.Reviews",
    "type": "replyreviews"
  },
  {
    "categories": [],
    "name": "Replyify",
    "type": "replyify"
  },
  {
    "categories": [],
    "name": "Repuso",
    "type": "repuso"
  },
  {
    "categories": [],
    "name": "Res:harmonics",
    "type": "resharmonics"
  },
  {
    "categories": [],
    "name": "Resemble AI",
    "type": "resembleai"
  },
  {
    "categories": [],
    "name": "Resly",
    "type": "resly"
  },
  {
    "categories": [],
    "name": "ResourceSpace",
    "type": "resourcespace"
  },
  {
    "categories": [],
    "name": "Respan AI",
    "type": "respanai"
  },
  {
    "categories": [],
    "name": "Respond Flow",
    "type": "respondflow"
  },
  {
    "categories": [],
    "name": "RestDB.io",
    "type": "restdbio"
  },
  {
    "categories": [],
    "name": "Resurs Bank",
    "type": "resursbank"
  },
  {
    "categories": [],
    "name": "Retell AI",
    "type": "retellai"
  },
  {
    "categories": [],
    "name": "Retriever",
    "type": "retriever"
  },
  {
    "categories": [],
    "name": "Rev.ai",
    "type": "revai"
  },
  {
    "categories": [],
    "name": "Rev.io",
    "type": "revio"
  },
  {
    "categories": [],
    "name": "Revaluate",
    "type": "revaluate"
  },
  {
    "categories": [],
    "name": "Revi",
    "type": "revi"
  },
  {
    "categories": [],
    "name": "Review Harvest",
    "type": "reviewharvest"
  },
  {
    "categories": [],
    "name": "Review Rover",
    "type": "reviewrover"
  },
  {
    "categories": [],
    "name": "Reviewnizer",
    "type": "reviewnizer"
  },
  {
    "categories": [],
    "name": "Revolt",
    "type": "revolt"
  },
  {
    "categories": [],
    "name": "RevReply",
    "type": "revreply"
  },
  {
    "categories": [],
    "name": "Reward Loyalty",
    "type": "rewardloyalty"
  },
  {
    "categories": [],
    "name": "Rewardful",
    "type": "rewardful"
  },
  {
    "categories": [],
    "name": "Rewix",
    "type": "rewix"
  },
  {
    "categories": [],
    "name": "Rezora",
    "type": "rezora"
  },
  {
    "categories": [],
    "name": "Rhythm Systems",
    "type": "rhythmsystems"
  },
  {
    "categories": [],
    "name": "Riser",
    "type": "riser"
  },
  {
    "categories": [],
    "name": "Riverty",
    "type": "riverty"
  },
  {
    "categories": [],
    "name": "Roadie",
    "type": "roadie"
  },
  {
    "categories": [],
    "name": "Robin",
    "type": "robin"
  },
  {
    "categories": [],
    "name": "RocketSkip",
    "type": "rocketskip"
  },
  {
    "categories": [],
    "name": "Romulus",
    "type": "romulus"
  },
  {
    "categories": [],
    "name": "Rose Rocket",
    "type": "roserocket"
  },
  {
    "categories": [],
    "name": "Route4Me",
    "type": "route4me"
  },
  {
    "categories": [],
    "name": "Routee",
    "type": "routee"
  },
  {
    "categories": [],
    "name": "RouteLogic",
    "type": "routelogic"
  },
  {
    "categories": [],
    "name": "RouterPlex",
    "type": "routerplex"
  },
  {
    "categories": [],
    "name": "Routine",
    "type": "routine"
  },
  {
    "categories": [],
    "name": "Royal Mail Click & Drop",
    "type": "royalmailclickdrop"
  },
  {
    "categories": [],
    "name": "RSS Ground",
    "type": "rssground"
  },
  {
    "categories": [],
    "name": "RunCloud",
    "type": "runcloud"
  },
  {
    "categories": [],
    "name": "RunSignup",
    "type": "runsignup"
  },
  {
    "categories": [],
    "name": "Runway",
    "type": "runway"
  },
  {
    "categories": [],
    "name": "Rybbit",
    "type": "rybbit"
  },
  {
    "categories": [],
    "name": "SaaSquatch",
    "type": "saasquatch"
  },
  {
    "categories": [],
    "name": "Sakari",
    "type": "sakari"
  },
  {
    "categories": [],
    "name": "SaladCloud",
    "type": "saladcloud"
  },
  {
    "categories": [],
    "name": "SambaNova Cloud",
    "type": "sambanovacloud"
  },
  {
    "categories": [],
    "name": "Sanity",
    "type": "sanity"
  },
  {
    "categories": [],
    "name": "SAP BTP Cloud Foundry",
    "type": "sapbtpcloudfoundry"
  },
  {
    "categories": [],
    "name": "Sarbacane",
    "type": "sarbacane"
  },
  {
    "categories": [],
    "name": "Satispay",
    "type": "satispay"
  },
  {
    "categories": [],
    "name": "SATORI",
    "type": "satori"
  },
  {
    "categories": [],
    "name": "Scalable Press",
    "type": "scalablepress"
  },
  {
    "categories": [],
    "name": "Scarlett Network",
    "type": "scarlettnetwork"
  },
  {
    "categories": [],
    "name": "Schoology",
    "type": "schoology"
  },
  {
    "categories": [],
    "name": "Scoop.it",
    "type": "scoopit"
  },
  {
    "categories": [],
    "name": "ScraperCity",
    "type": "scrapercity"
  },
  {
    "categories": [],
    "name": "Scriben",
    "type": "scriben"
  },
  {
    "categories": [],
    "name": "Seamless.AI",
    "type": "seamlessai"
  },
  {
    "categories": [],
    "name": "Second Street",
    "type": "secondstreet"
  },
  {
    "categories": [],
    "name": "SecPaid",
    "type": "secpaid"
  },
  {
    "categories": [],
    "name": "SeekTable",
    "type": "seektable"
  },
  {
    "categories": [],
    "name": "Sendar",
    "type": "sendar"
  },
  {
    "categories": [],
    "name": "Sendbee",
    "type": "sendbee"
  },
  {
    "categories": [],
    "name": "Sendcrux",
    "type": "sendcrux"
  },
  {
    "categories": [],
    "name": "SendHQ",
    "type": "sendhq"
  },
  {
    "categories": [],
    "name": "Sendible",
    "type": "sendible"
  },
  {
    "categories": [],
    "name": "Sendiio",
    "type": "sendiio"
  },
  {
    "categories": [],
    "name": "Sendit",
    "type": "sendit"
  },
  {
    "categories": [],
    "name": "Sendmsg",
    "type": "sendmsg"
  },
  {
    "categories": [],
    "name": "SendMsg SMS",
    "type": "sendmsgsms"
  },
  {
    "categories": [],
    "name": "Sendon",
    "type": "sendon"
  },
  {
    "categories": [],
    "name": "SendSafely",
    "type": "sendsafely"
  },
  {
    "categories": [],
    "name": "SendZen",
    "type": "sendzen"
  },
  {
    "categories": [],
    "name": "Serpro Vio",
    "type": "serprovio"
  },
  {
    "categories": [],
    "name": "Setu",
    "type": "setu"
  },
  {
    "categories": [],
    "name": "Seven Time",
    "type": "seventime"
  },
  {
    "categories": [],
    "name": "ShipMonk",
    "type": "shipmonk"
  },
  {
    "categories": [],
    "name": "Shippify",
    "type": "shippify"
  },
  {
    "categories": [],
    "name": "Shireburn Indigo",
    "type": "shireburnindigo"
  },
  {
    "categories": [],
    "name": "Shoprocket",
    "type": "shoprocket"
  },
  {
    "categories": [],
    "name": "Shovels",
    "type": "shovels"
  },
  {
    "categories": [],
    "name": "Showdigs",
    "type": "showdigs"
  },
  {
    "categories": [],
    "name": "ShowMyRep",
    "type": "showmyrep"
  },
  {
    "categories": [],
    "name": "Showpad",
    "type": "showpad"
  },
  {
    "categories": [],
    "name": "SIEG",
    "type": "sieg"
  },
  {
    "categories": [],
    "name": "Siemens Teamcenter",
    "type": "siemensteamcenter"
  },
  {
    "categories": [],
    "name": "SigmaMind AI",
    "type": "sigmamindai"
  },
  {
    "categories": [],
    "name": "Signicat",
    "type": "signicat"
  },
  {
    "categories": [],
    "name": "SIGNL4",
    "type": "signl4"
  },
  {
    "categories": [],
    "name": "SignUpGenius",
    "type": "signupgenius"
  },
  {
    "categories": [],
    "name": "Signzy",
    "type": "signzy"
  },
  {
    "categories": [],
    "name": "SimpleNexus (nCino Mortgage)",
    "type": "simplenexusncinomortgage"
  },
  {
    "categories": [],
    "name": "SimplePDF",
    "type": "simplepdf"
  },
  {
    "categories": [],
    "name": "Sinao",
    "type": "sinao"
  },
  {
    "categories": [],
    "name": "SingleStore",
    "type": "singlestore"
  },
  {
    "categories": [],
    "name": "Sinthoma",
    "type": "sinthoma"
  },
  {
    "categories": [],
    "name": "Sipay",
    "type": "sipay"
  },
  {
    "categories": [],
    "name": "Skaala",
    "type": "skaala"
  },
  {
    "categories": [],
    "name": "Skedda",
    "type": "skedda"
  },
  {
    "categories": [],
    "name": "Skhokho",
    "type": "skhokho"
  },
  {
    "categories": [],
    "name": "Skill Spark",
    "type": "skillspark"
  },
  {
    "categories": [],
    "name": "SkillzRun",
    "type": "skillzrun"
  },
  {
    "categories": [],
    "name": "Skipio",
    "type": "skipio"
  },
  {
    "categories": [],
    "name": "Skiv",
    "type": "skiv"
  },
  {
    "categories": [],
    "name": "Skool",
    "type": "skool"
  },
  {
    "categories": [],
    "name": "SlapFive",
    "type": "slapfive"
  },
  {
    "categories": [],
    "name": "SleekFlow",
    "type": "sleekflow"
  },
  {
    "categories": [],
    "name": "Slickstream",
    "type": "slickstream"
  },
  {
    "categories": [],
    "name": "SlideRoom",
    "type": "slideroom"
  },
  {
    "categories": [],
    "name": "Slope",
    "type": "slope"
  },
  {
    "categories": [],
    "name": "Slottable",
    "type": "slottable"
  },
  {
    "categories": [],
    "name": "Slybroadcast",
    "type": "slybroadcast"
  },
  {
    "categories": [],
    "name": "Smart Glocal",
    "type": "smartglocal"
  },
  {
    "categories": [],
    "name": "SmartDialog",
    "type": "smartdialog"
  },
  {
    "categories": [],
    "name": "Smartlook",
    "type": "smartlook"
  },
  {
    "categories": [],
    "name": "SmartSuite",
    "type": "smartsuite"
  },
  {
    "categories": [],
    "name": "Smile",
    "type": "smile"
  },
  {
    "categories": [],
    "name": "Smore",
    "type": "smore"
  },
  {
    "categories": [],
    "name": "SMTPfast",
    "type": "smtpfast"
  },
  {
    "categories": [],
    "name": "Snackeet",
    "type": "snackeet"
  },
  {
    "categories": [],
    "name": "SnapEngage",
    "type": "snapengage"
  },
  {
    "categories": [],
    "name": "Snitcher",
    "type": "snitcher"
  },
  {
    "categories": [],
    "name": "SocialBee",
    "type": "socialbee"
  },
  {
    "categories": [],
    "name": "Socket",
    "type": "socket"
  },
  {
    "categories": [],
    "name": "Softr Databases",
    "type": "softrdatabases"
  },
  {
    "categories": [],
    "name": "Soldo",
    "type": "soldo"
  },
  {
    "categories": [],
    "name": "solidtime",
    "type": "solidtime"
  },
  {
    "categories": [],
    "name": "SortScape",
    "type": "sortscape"
  },
  {
    "categories": [],
    "name": "SourceWhale",
    "type": "sourcewhale"
  },
  {
    "categories": [],
    "name": "SparkPost",
    "type": "sparkpost"
  },
  {
    "categories": [],
    "name": "Speak Ai",
    "type": "speakai"
  },
  {
    "categories": [],
    "name": "SpectroCoin",
    "type": "spectrocoin"
  },
  {
    "categories": [],
    "name": "Spektrix",
    "type": "spektrix"
  },
  {
    "categories": [],
    "name": "Spiky",
    "type": "spiky"
  },
  {
    "categories": [],
    "name": "SPLASH Click & Collect",
    "type": "splashclickcollect"
  },
  {
    "categories": [],
    "name": "Splunk (Enterprise + Cloud) as a data source",
    "type": "splunkenterprisecloudasadatasource"
  },
  {
    "categories": [],
    "name": "Spot by Flexera",
    "type": "spotbyflexera"
  },
  {
    "categories": [],
    "name": "SpotDraft",
    "type": "spotdraft"
  },
  {
    "categories": [],
    "name": "Spreadshirt",
    "type": "spreadshirt"
  },
  {
    "categories": [],
    "name": "Spreedly",
    "type": "spreedly"
  },
  {
    "categories": [],
    "name": "Sprig",
    "type": "sprig"
  },
  {
    "categories": [],
    "name": "Sprinklr",
    "type": "sprinklr"
  },
  {
    "categories": [],
    "name": "Sprout Social",
    "type": "sproutsocial"
  },
  {
    "categories": [],
    "name": "Sqala",
    "type": "sqala"
  },
  {
    "categories": [],
    "name": "Squidex",
    "type": "squidex"
  },
  {
    "categories": [],
    "name": "Stability AI",
    "type": "stabilityai"
  },
  {
    "categories": [],
    "name": "StaffViz",
    "type": "staffviz"
  },
  {
    "categories": [],
    "name": "Stafiz",
    "type": "stafiz"
  },
  {
    "categories": [],
    "name": "Stamps.com",
    "type": "stampscom"
  },
  {
    "categories": [],
    "name": "Stannp",
    "type": "stannp"
  },
  {
    "categories": [],
    "name": "Starveri",
    "type": "starveri"
  },
  {
    "categories": [],
    "name": "StatHat",
    "type": "stathat"
  },
  {
    "categories": [],
    "name": "StealthSeminar",
    "type": "stealthseminar"
  },
  {
    "categories": [],
    "name": "Stellastra",
    "type": "stellastra"
  },
  {
    "categories": [],
    "name": "Storecove",
    "type": "storecove"
  },
  {
    "categories": [],
    "name": "Storeplum",
    "type": "storeplum"
  },
  {
    "categories": [],
    "name": "Storj",
    "type": "storj"
  },
  {
    "categories": [],
    "name": "Storyblok",
    "type": "storyblok"
  },
  {
    "categories": [],
    "name": "Straddle",
    "type": "straddle"
  },
  {
    "categories": [],
    "name": "Strapi",
    "type": "strapi"
  },
  {
    "categories": [],
    "name": "Streak",
    "type": "streak"
  },
  {
    "categories": [],
    "name": "Stream",
    "type": "stream"
  },
  {
    "categories": [],
    "name": "StrikeAI",
    "type": "strikeai"
  },
  {
    "categories": [],
    "name": "Strive",
    "type": "strive"
  },
  {
    "categories": [],
    "name": "StubHub",
    "type": "stubhub"
  },
  {
    "categories": [],
    "name": "Submittable",
    "type": "submittable"
  },
  {
    "categories": [],
    "name": "Subtraq",
    "type": "subtraq"
  },
  {
    "categories": [],
    "name": "Sumit",
    "type": "sumit"
  },
  {
    "categories": [],
    "name": "SumoQuote",
    "type": "sumoquote"
  },
  {
    "categories": [],
    "name": "Sumsub",
    "type": "sumsub"
  },
  {
    "categories": [],
    "name": "Supabugs",
    "type": "supabugs"
  },
  {
    "categories": [],
    "name": "Superbot",
    "type": "superbot"
  },
  {
    "categories": [],
    "name": "Superforms",
    "type": "superforms"
  },
  {
    "categories": [],
    "name": "SupportBox",
    "type": "supportbox"
  },
  {
    "categories": [],
    "name": "SuprSend",
    "type": "suprsend"
  },
  {
    "categories": [],
    "name": "Sure Send",
    "type": "suresend"
  },
  {
    "categories": [],
    "name": "SureCart",
    "type": "surecart"
  },
  {
    "categories": [],
    "name": "SureVoIP",
    "type": "surevoip"
  },
  {
    "categories": [],
    "name": "Surveypal",
    "type": "surveypal"
  },
  {
    "categories": [],
    "name": "SurveyRock",
    "type": "surveyrock"
  },
  {
    "categories": [],
    "name": "SurveySparrow",
    "type": "surveysparrow"
  },
  {
    "categories": [],
    "name": "Survicate",
    "type": "survicate"
  },
  {
    "categories": [],
    "name": "Survser",
    "type": "survser"
  },
  {
    "categories": [],
    "name": "Swapkaart",
    "type": "swapkaart"
  },
  {
    "categories": [],
    "name": "SwarmNode",
    "type": "swarmnode"
  },
  {
    "categories": [],
    "name": "Swatle",
    "type": "swatle"
  },
  {
    "categories": [],
    "name": "Swift Check Processing",
    "type": "swiftcheckprocessing"
  },
  {
    "categories": [],
    "name": "Swiftchats",
    "type": "swiftchats"
  },
  {
    "categories": [],
    "name": "SwiftFox CRM",
    "type": "swiftfoxcrm"
  },
  {
    "categories": [],
    "name": "Sydnee",
    "type": "sydnee"
  },
  {
    "categories": [],
    "name": "Sync Labs",
    "type": "synclabs"
  },
  {
    "categories": [],
    "name": "Synchroteam",
    "type": "synchroteam"
  },
  {
    "categories": [],
    "name": "Synctera",
    "type": "synctera"
  },
  {
    "categories": [],
    "name": "SYNDUIT",
    "type": "synduit"
  },
  {
    "categories": [],
    "name": "Synthflow AI",
    "type": "synthflowai"
  },
  {
    "categories": [],
    "name": "Tabidoo",
    "type": "tabidoo"
  },
  {
    "categories": [],
    "name": "Tadabase",
    "type": "tadabase"
  },
  {
    "categories": [],
    "name": "Taggbox",
    "type": "taggbox"
  },
  {
    "categories": [],
    "name": "Taktikal",
    "type": "taktikal"
  },
  {
    "categories": [],
    "name": "TalkBox",
    "type": "talkbox"
  },
  {
    "categories": [],
    "name": "TalkFurther",
    "type": "talkfurther"
  },
  {
    "categories": [],
    "name": "Tall Bob",
    "type": "tallbob"
  },
  {
    "categories": [],
    "name": "Targa",
    "type": "targa"
  },
  {
    "categories": [],
    "name": "Tarvent",
    "type": "tarvent"
  },
  {
    "categories": [],
    "name": "TaxBandits",
    "type": "taxbandits"
  },
  {
    "categories": [],
    "name": "taxiCRM",
    "type": "taxicrm"
  },
  {
    "categories": [],
    "name": "TCDial",
    "type": "tcdial"
  },
  {
    "categories": [],
    "name": "TDox",
    "type": "tdox"
  },
  {
    "categories": [],
    "name": "TeamBuildr",
    "type": "teambuildr"
  },
  {
    "categories": [],
    "name": "Teem (Eptura)",
    "type": "teemeptura"
  },
  {
    "categories": [],
    "name": "Telegram Finder",
    "type": "telegramfinder"
  },
  {
    "categories": [],
    "name": "Telintel",
    "type": "telintel"
  },
  {
    "categories": [],
    "name": "Tellescope",
    "type": "tellescope"
  },
  {
    "categories": [],
    "name": "Terros",
    "type": "terros"
  },
  {
    "categories": [],
    "name": "Text2reach",
    "type": "text2reach"
  },
  {
    "categories": [],
    "name": "TextBetter",
    "type": "textbetter"
  },
  {
    "categories": [],
    "name": "The Events Calendar",
    "type": "theeventscalendar"
  },
  {
    "categories": [],
    "name": "Theteller",
    "type": "theteller"
  },
  {
    "categories": [],
    "name": "Thirdlane",
    "type": "thirdlane"
  },
  {
    "categories": [],
    "name": "ThriveCart",
    "type": "thrivecart"
  },
  {
    "categories": [],
    "name": "Thunes",
    "type": "thunes"
  },
  {
    "categories": [],
    "name": "Ticketbud",
    "type": "ticketbud"
  },
  {
    "categories": [],
    "name": "TicketCo",
    "type": "ticketco"
  },
  {
    "categories": [],
    "name": "TicketSource",
    "type": "ticketsource"
  },
  {
    "categories": [],
    "name": "Tige Consulta CNH",
    "type": "tigeconsultacnh"
  },
  {
    "categories": [],
    "name": "TigoPesa",
    "type": "tigopesa"
  },
  {
    "categories": [],
    "name": "Time etc",
    "type": "timeetc"
  },
  {
    "categories": [],
    "name": "Timekit",
    "type": "timekit"
  },
  {
    "categories": [],
    "name": "Timesheet.io",
    "type": "timesheetio"
  },
  {
    "categories": [],
    "name": "timetoreply",
    "type": "timetoreply"
  },
  {
    "categories": [],
    "name": "Timetracker",
    "type": "timetracker"
  },
  {
    "categories": [],
    "name": "Tixio",
    "type": "tixio"
  },
  {
    "categories": [],
    "name": "Together AI",
    "type": "togetherai"
  },
  {
    "categories": [],
    "name": "Tokopedia",
    "type": "tokopedia"
  },
  {
    "categories": [],
    "name": "Toky",
    "type": "toky"
  },
  {
    "categories": [],
    "name": "Tookan",
    "type": "tookan"
  },
  {
    "categories": [],
    "name": "Torod SmartShip",
    "type": "torodsmartship"
  },
  {
    "categories": [],
    "name": "Toss Payments",
    "type": "tosspayments"
  },
  {
    "categories": [],
    "name": "Total Synergy",
    "type": "totalsynergy"
  },
  {
    "categories": [],
    "name": "Track-POD",
    "type": "trackpod"
  },
  {
    "categories": [],
    "name": "Trackabi",
    "type": "trackabi"
  },
  {
    "categories": [],
    "name": "Tradable Bits",
    "type": "tradablebits"
  },
  {
    "categories": [],
    "name": "TramitApp",
    "type": "tramitapp"
  },
  {
    "categories": [],
    "name": "Transbank Webpay Plus",
    "type": "transbankwebpayplus"
  },
  {
    "categories": [],
    "name": "Transkriptor",
    "type": "transkriptor"
  },
  {
    "categories": [],
    "name": "Trimble Connect",
    "type": "trimbleconnect"
  },
  {
    "categories": [],
    "name": "Trimble Field Service Management",
    "type": "trimblefieldservicemanagement"
  },
  {
    "categories": [],
    "name": "Trimble Viewpoint Vista",
    "type": "trimbleviewpointvista"
  },
  {
    "categories": [],
    "name": "Triquestra Infinity",
    "type": "triquestrainfinity"
  },
  {
    "categories": [],
    "name": "TruAnon",
    "type": "truanon"
  },
  {
    "categories": [],
    "name": "Trucker Tools",
    "type": "truckertools"
  },
  {
    "categories": [],
    "name": "TrueLayer",
    "type": "truelayer"
  },
  {
    "categories": [],
    "name": "Truffle",
    "type": "truffle"
  },
  {
    "categories": [],
    "name": "Trune",
    "type": "trune"
  },
  {
    "categories": [],
    "name": "Truora",
    "type": "truora"
  },
  {
    "categories": [],
    "name": "Truss",
    "type": "truss"
  },
  {
    "categories": [],
    "name": "Trust Swiftly",
    "type": "trustswiftly"
  },
  {
    "categories": [],
    "name": "Trusted Shops eTrusted",
    "type": "trustedshopsetrusted"
  },
  {
    "categories": [],
    "name": "Tuemilio",
    "type": "tuemilio"
  },
  {
    "categories": [],
    "name": "TurboSMTP",
    "type": "turbosmtp"
  },
  {
    "categories": [],
    "name": "Tyme",
    "type": "tyme"
  },
  {
    "categories": [],
    "name": "Uber Direct",
    "type": "uberdirect"
  },
  {
    "categories": [],
    "name": "Uku",
    "type": "uku"
  },
  {
    "categories": [],
    "name": "Unifiedpost",
    "type": "unifiedpost"
  },
  {
    "categories": [],
    "name": "Univid",
    "type": "univid"
  },
  {
    "categories": [],
    "name": "Upcoach",
    "type": "upcoach"
  },
  {
    "categories": [],
    "name": "Updox",
    "type": "updox"
  },
  {
    "categories": [],
    "name": "Upnify",
    "type": "upnify"
  },
  {
    "categories": [],
    "name": "Upvoit",
    "type": "upvoit"
  },
  {
    "categories": [],
    "name": "Upwork",
    "type": "upwork"
  },
  {
    "categories": [],
    "name": "Vectara",
    "type": "vectara"
  },
  {
    "categories": [],
    "name": "Vectron (by Shift4)",
    "type": "vectronbyshift4"
  },
  {
    "categories": [],
    "name": "Velo Payments",
    "type": "velopayments"
  },
  {
    "categories": [],
    "name": "Verifyd",
    "type": "verifyd"
  },
  {
    "categories": [],
    "name": "Veripoint",
    "type": "veripoint"
  },
  {
    "categories": [],
    "name": "Vero",
    "type": "vero"
  },
  {
    "categories": [],
    "name": "Viber",
    "type": "viber"
  },
  {
    "categories": [],
    "name": "Vibrato",
    "type": "vibrato"
  },
  {
    "categories": [],
    "name": "Visible",
    "type": "visible"
  },
  {
    "categories": [],
    "name": "VivifyScrum",
    "type": "vivifyscrum"
  },
  {
    "categories": [],
    "name": "VK",
    "type": "vk"
  },
  {
    "categories": [],
    "name": "Vlow",
    "type": "vlow"
  },
  {
    "categories": [],
    "name": "VNPAY",
    "type": "vnpay"
  },
  {
    "categories": [],
    "name": "Voiso",
    "type": "voiso"
  },
  {
    "categories": [],
    "name": "Volt",
    "type": "volt"
  },
  {
    "categories": [],
    "name": "Voluum",
    "type": "voluum"
  },
  {
    "categories": [],
    "name": "Voxloud",
    "type": "voxloud"
  },
  {
    "categories": [],
    "name": "Voyage AI",
    "type": "voyageai"
  },
  {
    "categories": [],
    "name": "Voyager Infinity",
    "type": "voyagerinfinity"
  },
  {
    "categories": [],
    "name": "Vuala",
    "type": "vuala"
  },
  {
    "categories": [],
    "name": "Vuepak",
    "type": "vuepak"
  },
  {
    "categories": [],
    "name": "Vyte",
    "type": "vyte"
  },
  {
    "categories": [],
    "name": "WaAPI",
    "type": "waapi"
  },
  {
    "categories": [],
    "name": "Waitlio",
    "type": "waitlio"
  },
  {
    "categories": [],
    "name": "Wallester",
    "type": "wallester"
  },
  {
    "categories": [],
    "name": "Walls.io",
    "type": "wallsio"
  },
  {
    "categories": [],
    "name": "WANNME",
    "type": "wannme"
  },
  {
    "categories": [],
    "name": "Way We Do",
    "type": "waywedo"
  },
  {
    "categories": [],
    "name": "Wayfront",
    "type": "wayfront"
  },
  {
    "categories": [],
    "name": "Waystar",
    "type": "waystar"
  },
  {
    "categories": [],
    "name": "Wbiztool",
    "type": "wbiztool"
  },
  {
    "categories": [],
    "name": "Webconnex",
    "type": "webconnex"
  },
  {
    "categories": [],
    "name": "WebinarJam",
    "type": "webinarjam"
  },
  {
    "categories": [],
    "name": "Webshipper",
    "type": "webshipper"
  },
  {
    "categories": [],
    "name": "WeCP",
    "type": "wecp"
  },
  {
    "categories": [],
    "name": "Weedmaps",
    "type": "weedmaps"
  },
  {
    "categories": [],
    "name": "Weezevent",
    "type": "weezevent"
  },
  {
    "categories": [],
    "name": "Weibo",
    "type": "weibo"
  },
  {
    "categories": [],
    "name": "WhatConverts",
    "type": "whatconverts"
  },
  {
    "categories": [],
    "name": "Whatnot",
    "type": "whatnot"
  },
  {
    "categories": [],
    "name": "Whereby",
    "type": "whereby"
  },
  {
    "categories": [],
    "name": "WHMCS",
    "type": "whmcs"
  },
  {
    "categories": [],
    "name": "WholeStory",
    "type": "wholestory"
  },
  {
    "categories": [],
    "name": "Wompi",
    "type": "wompi"
  },
  {
    "categories": [],
    "name": "WorkflowMax",
    "type": "workflowmax"
  },
  {
    "categories": [],
    "name": "WorkOS",
    "type": "workos"
  },
  {
    "categories": [],
    "name": "Worksection",
    "type": "worksection"
  },
  {
    "categories": [],
    "name": "Worldline Bambora",
    "type": "worldlinebambora"
  },
  {
    "categories": [],
    "name": "Wrangle",
    "type": "wrangle"
  },
  {
    "categories": [],
    "name": "wunderbon",
    "type": "wunderbon"
  },
  {
    "categories": [],
    "name": "Xobin",
    "type": "xobin"
  },
  {
    "categories": [],
    "name": "XTRF",
    "type": "xtrf"
  },
  {
    "categories": [],
    "name": "Yapla",
    "type": "yapla"
  },
  {
    "categories": [],
    "name": "Yeti Snow",
    "type": "yetisnow"
  },
  {
    "categories": [],
    "name": "Yoco",
    "type": "yoco"
  },
  {
    "categories": [],
    "name": "You.com",
    "type": "youcom"
  },
  {
    "categories": [],
    "name": "yourang",
    "type": "yourang"
  },
  {
    "categories": [],
    "name": "ZaloPay",
    "type": "zalopay"
  },
  {
    "categories": [],
    "name": "ZAPKELLER",
    "type": "zapkeller"
  },
  {
    "categories": [],
    "name": "Zeliq",
    "type": "zeliq"
  },
  {
    "categories": [],
    "name": "Zenduty",
    "type": "zenduty"
  },
  {
    "categories": [],
    "name": "Zenegy",
    "type": "zenegy"
  },
  {
    "categories": [],
    "name": "Zengine",
    "type": "zengine"
  },
  {
    "categories": [],
    "name": "Zengine (Submittable)",
    "type": "zenginesubmittable"
  },
  {
    "categories": [],
    "name": "Zenkit",
    "type": "zenkit"
  },
  {
    "categories": [],
    "name": "Zenvia",
    "type": "zenvia"
  },
  {
    "categories": [],
    "name": "Zip",
    "type": "zip"
  },
  {
    "categories": [],
    "name": "Zivvy",
    "type": "zivvy"
  },
  {
    "categories": [],
    "name": "Ziwo",
    "type": "ziwo"
  },
  {
    "categories": [],
    "name": "Zocdoc",
    "type": "zocdoc"
  },
  {
    "categories": [],
    "name": "Zocks",
    "type": "zocks"
  },
  {
    "categories": [],
    "name": "Zoho Catalyst",
    "type": "zohocatalyst"
  },
  {
    "categories": [],
    "name": "Zoho FSM",
    "type": "zohofsm"
  },
  {
    "categories": [],
    "name": "Zoho Sheet",
    "type": "zohosheet"
  },
  {
    "categories": [],
    "name": "Zoho Writer",
    "type": "zohowriter"
  },
  {
    "categories": [],
    "name": "Zoom Connect",
    "type": "zoomconnect"
  },
  {
    "categories": [],
    "name": "Zoom Contact Center",
    "type": "zoomcontactcenter"
  },
  {
    "categories": [],
    "name": "Zube",
    "type": "zube"
  },
  {
    "categories": [],
    "name": "Zuora Billing",
    "type": "zuorabilling"
  }
]